import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {gql, Apollo} from 'apollo-angular';
import { AuthService } from 'src/app/auth/services/auth.service';
import { NavigationService } from 'src/app/_services/navigation';
import {NgbDateStruct, NgbCalendar, NgbModalRef, NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { onError } from "apollo-link-error";
import { Observable, OperatorFunction, Subject, Subscription, forkJoin, from, of } from 'rxjs';
import { DataService } from 'src/app/_services/data';
import { DatePipe } from '@angular/common';
import Getcurrency from 'src/app/_helpers/currency';
import Getcountrycity from 'src/app/_helpers/city';
import Util from 'src/app/_helpers/util';
import moment from 'moment';
import Option from 'src/app/_helpers/option';

import {catchError, concatMap, debounceTime, distinctUntilChanged, map} from 'rxjs/operators';
import { RfqProcurementService } from 'src/app/_services/rfqprocurement.services';
import { ModalComponent } from 'src/app/components/modal/modal.component';
import { Popupmodal } from 'src/app/_helpers/popupmodal';
import CheckErrortype from 'src/app/_helpers/check-errortype';
import { TranslateService } from '@ngx-translate/core';
import { UploadImagesService } from 'src/app/_services/uploadImages.services';
import { ImgHandler } from 'src/app/_helpers/img-handler';
import { HttpClient } from '@angular/common/http';


const getcountry = gql`
query{
  registrationPage{
      subscriptionId
      countryItem{
          id
          countryName
          currency
      }
  }
}
`;


const getcompanylocation = gql`
query{
  getCompanyLocationList{
      id
      label
      country
      province
      city
      street
      postalCode
      phone
      taxId
      isMainAddress
  }
}
`;


// const getCategory = gql`
// query loadSystemIndustryList($first: Int!, $after: String!) {
//   loadSystemIndustryList(input: {first: $first, after: $after}) {
//         pageInfo{
//             endCursor
//             hasNextPage
//         }
//       edges{
//           cursor
//           node{
//               id
//               industry
//               description
//           }
//       }
//   }
// }
// `;

const getRrfqDetail = gql`
query getRfqDetail($rfqId: ID!) {
  getRfqDetail(input: {rfqId: $rfqId}) {
    isAlreadyParticipating
    rfq {
        id
        companyLocation {
            id
            label
            country
            province
            city
            street
            postalCode
            phone
            taxId
            isMainAddress
        }
        state
        approvalStatus
        ongoingApprovalStatus
        rfqDisplayId
        description,
        submitQuotationLastDate
        paymentTermRequestedInDays
        etaRequested
        currency
        procurementRefNumber
        isForFullQuote
        isIndentAccepted
        expiredDate
        rfqItem {
            id
            name
            brand
            description
            qtyNeeded
            manufacturerSku
            itemSequence
            itemUnit
        }
        rfqVendorCategory {
            id
            category
        }
        totalVendorParticipation
        createdDate
        createdBy
        modifiedDate
        modifiedBy
    } 
  }
}
`;





const postRfq = gql`
mutation insertRfq($companyLocationId: ID!, $description: String!, $submitQuotationLastDate: String!, $paymentTermRequestedInDays: Int!, $etaRequested: String!, $currency: String!, $procurementRefNumber: String!, $isForFullQuote: Boolean!, $isIndentAccepted: Boolean!, $rfqItem: [RfqItemInput!]!, $rfqVendorCategory: [String!]){
  insertRfq(input: {
      companyLocationId: $companyLocationId,
      description: $description,
      submitQuotationLastDate: $submitQuotationLastDate,
      paymentTermRequestedInDays: $paymentTermRequestedInDays,
      etaRequested: $etaRequested,
      currency: $currency,
      procurementRefNumber: $procurementRefNumber,
      isForFullQuote: $isForFullQuote,
      isIndentAccepted: $isIndentAccepted,
      rfqItem: $rfqItem,
      rfqVendorCategory: $rfqVendorCategory
  }){
      id
              companyLocation {
                  id
                  label
                  country
                  province
                  city
                  street
                  postalCode
                  phone
                  taxId
                  isMainAddress
              }
              state
              approvalStatus
              ongoingApprovalStatus
              rfqDisplayId
              description,
              submitQuotationLastDate
              paymentTermRequestedInDays
              etaRequested
              currency
              procurementRefNumber
              isForFullQuote
              isIndentAccepted
              expiredDate
              rfqItem {
                  id
                  name
                  brand
                  description
                  qtyNeeded
                  manufacturerSku
                  itemSequence
                  itemUnit
              }
              rfqVendorCategory {
                  id
                  category
              }
              createdDate
              createdBy
              modifiedDate
              modifiedBy
  }
}
`;

const editRfq = gql`
mutation updateRfq(
  $rfqId: ID!,
  $rfqUpdateInputData: RfqUpdateInputData!,
  ){
  updateRfq(input: {
    rfqId: $rfqId, 
    rfqUpdateInputData: $rfqUpdateInputData
  }){
      id
              companyLocation {
                  id
                  label
                  country
                  province
                  city
                  street
                  postalCode
                  phone
                  taxId
                  isMainAddress
              }
              state
              approvalStatus
              ongoingApprovalStatus
              rfqDisplayId
              description,
              submitQuotationLastDate
              paymentTermRequestedInDays
              etaRequested
              currency
              procurementRefNumber
              isForFullQuote
              isIndentAccepted
              expiredDate
              rfqItem {
                  id
                  name
                  brand
                  description
                  qtyNeeded
                  manufacturerSku
                  itemSequence
                  itemUnit
                  fileName
              }
              rfqVendorCategory {
                  id
                  category
              }
              createdDate
              createdBy
              modifiedDate
              modifiedBy
  }
}
`;


@Component({
  selector: 'app-draft-rfq',
  templateUrl: './draft-rfq.component.html',
  styleUrls: ['./draft-rfq.component.scss'],
  providers: [DatePipe]
})
export class DraftRfqComponent implements OnInit {
  first : number = 20
  pageloading:boolean=false
  dataRfq: any
  AlldataRfq : any =[]
  endCursor: any=''
  hasNextPage: any = true
  hasPrevPage:any = false
  arrPrevCursor:any=[]
  EditRfqId:any


  dataCategoryList:any = null
  AlldataCategoryList:any =[]
  categoryfirst : number = 24
  categoryendCursor: any=''
  categoryhasNextPage: any = true
  categoryhasPrevPage:any = false
  allCategoryLoaded:boolean=false
  CategoryPage:number = 0
  LastCategoryPage:number = 0
  CategoryShown:any=[]
  selectedCat:any=[]

  rfqForm = this.formBuilder.group({
    companyLocationId: [''],
    description: [''],
    submitQuotationLastDate: ['', Validators.required],
    paymentTermRequestedInDays: [''],
    etaRequested: [''],
    currency: ['', Validators.required],
    procurementRefNumber:  [''],
    isForFullQuote: [''],
    isIndentAccepted: [''],
    rfqItem: [''],
    rfqVendorCategory:[''],
    country: ['', Validators.required]
  });
  submitted = false;
  rfqFormInvalid:boolean=false
  btnloading:boolean=false

  ValcompanyLocationId:string=''
  Valdescription:string="<fhspecdiv>[]</fhspecdiv>"
  ValsubmitQuotationLastDate:any
  ValpaymentTermRequestedInDays:any=null
  ValpaymentTermRequestedInDaysPrev:any=null
  ValetaRequested:any
  Valcurrency:string=''
  ValprocurementRefNumber:string=''
  ValisForFullQuote:boolean=false
  ValisIndentAccepted:boolean=true
  ValrfqItem:string=''
  ValrfqVendorCategory:string=''
  ValCountry:string=''
  ValCountryShow:string='Select Location'
  ValCountryDetailarr:any=[]

  ArrRfqItem:any=[]

  ValetaRequestedPreview:any
  ValsubmitQuotationLastDatePreview:any

  successdraft:boolean=false
  countries : any;
  getCompanyLocation : any


  cateories = [
    {
      title: 'Accordion Item 1',
      children: [{ title: 'Child 1.1' }, { title: 'Child 1.2' }]
    },
    {
      title: 'Accordion Item 2',
      children: [{ title: 'Child 2.1' }, { title: 'Child 2.2' }]
    },
    {
      title: 'Accordion Item 3',
      children: [
        { title: 'Child 3.1' },
        { title: 'Child 3.2' },
        { title: 'Child 3.3' }
      ]
    }
  ];

  //product add / edit
  productList:any=[]

  Valid:any=[]
  Valname:any=[]
  Valbrand:any=[]
  ValdescriptionProduct:any=[]
  ValqtyNeeded:any=[]
  ValmanufacturerSku:any=[]
  //ValitemSequence:any=[]

  ValqtyUnit:any=[]



  accordionStatus:any=[]

  imageSrc: string=''
  imageSrcMore:any=[]
  ValimageMore:any=[]
  // MoreImgCount = new Array(3);
  // MoreImgCount = new Array(0);
  MoreImgCount: any =[]
  MoreImgArr:any = []
  CombineImg:any = []
  ValimageFileName:string=''

  valspecLabel:any=[]
  valspecValue:any=[]

  emptyLabelSpec : any = []
  emptyValueSpec : any = []

  ValSpecEmpty:any=[]
  valspecValueErr: any=[]
  valspecLabelErr:any=[]

  divFhSpec :any=[] // <fhspecdiv>[]</fhspecdiv>
  countarrFhSpec:any =[]

  tags:any=[]
  SelectedTags:any=[]
  dropdownListTag:any;
  selectedItemsTag:any=[];
  dropdownSettingsTag:any;
  emptyitem: boolean=false;

  minDate: any
  maxDate: any

  successResponse:boolean=false;
  successResponseName:string=''

  displaydraft='none'
  displaydone='none'
  actionbtn:any='' //draft , preview, done

  modalCategories: boolean=false

  message:string | undefined;
  subscription: Subscription | undefined;
  arrCategoryfromEdit: any=[];

  ValSearchtext:string=''
  CategoryNotFound:boolean=false
  closeResult: string | undefined;
  modalReference: NgbModalRef | undefined;

  SuggestCategoryForm = this.formBuilder.group({
    suggestCategory: ['',[Validators.required,Validators.maxLength(30),Validators.minLength(3)]]
  });
  myControl = new FormControl();
  consoleMessages: string[] = [];
  valKeyword:string=''
  iconloading:boolean=false
  resultKeyword:any=[]
  onsearchKeyword:boolean=false

  valsuggestCategory:string=''
  suggestsubmitted:boolean=false

  thousandQtyOption = Option.qtythousand()
  paymentTermOption = Option.paymentTerm()
  ValqtyNeededPrev:any=[]

  // states = ['Alabama', 'Alaska', 'American Samoa', 'Arizona', 'Arkansas', 'California', 'Colorado',
  // 'Connecticut', 'Delaware', 'District Of Columbia', 'Federated States Of Micronesia', 'Florida', 'Georgia',
  // 'Guam', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine',
  // 'Marshall Islands', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana',
  // 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota',
  // 'Northern Mariana Islands', 'Ohio', 'Oklahoma', 'Oregon', 'Palau', 'Pennsylvania', 'Puerto Rico', 'Rhode Island',
  // 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virgin Islands', 'Virginia',
  // 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'];

  states = Getcurrency.getAll();

  // formatter = (result: string) => result.toUpperCase();
  formatter = (result: string) => result;

  search: OperatorFunction<string, readonly string[]> = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => term === '' ? []
        : this.states.filter((v: string) => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
    )
  

    valmodel: any;

    // errorUploadImg:boolean=false
    errorUploadImg:any=[]
    ValimageMoreText:any=[]


    CombineImgData:any=[]

    UpdateimageData:any=[] 
    getImgDetail:string[]=[]
    imgAwsName:any[]=[]
    totalUpload:number=0
    successUpload:number=0
    productImagePreSignedUrl:any=[]
    arrPostImgWithID:any=[]
    ValfileName:any=[]
    SuccessInsertorUpdate:any

    postChangesImg:any=[]
    loadingAddProduct:boolean=false

    ArrResizeImage:any[] = []

  // add address (saved to localStorage pending API post)
  addAddressModal:string = 'none'
  addresssubmitted:boolean = false

  emailDraftModal:string = 'none'
  ValDraftEmail:string = ''
  emailDraftSubmitted:boolean = false
  emailDraftLoading:boolean = false
  addressloading:boolean = false
  cities:any = []
  countriesAddr:any = []
  closeDropdownSelection:boolean = false
  dropdownSettings:any = {}
  Vallabel:string = ''
  Valcountry:any = ['Indonesia']
  Valprovince:string = ''
  Valcity:any = ''
  Valstreet:string = ''
  ValpostalCode:string = ''
  Valphone:string = ''
  ValtaxId:string = ''
  ValisMainAddress:boolean = false

  AddressForm = new FormGroup({
    addrLabel:   new FormControl(''),
    addrCountry: new FormControl('', Validators.required),
    addrCity:    new FormControl('', Validators.required),
    addrStreet:  new FormControl('', Validators.required),
  })

  constructor(
    private formBuilder: FormBuilder,
    private apollo: Apollo,
    private cdRef: ChangeDetectorRef,
    private navigation: NavigationService,
    private router: Router,
    private authService: AuthService,
    private calendar: NgbCalendar,
    private route: ActivatedRoute,
    private data: DataService,
    private modalService: NgbModal,
    private rfqProcurementService: RfqProcurementService,
    public datepipe: DatePipe,
    private popupmodal : Popupmodal,
    private translate: TranslateService,
    public imgHandler: ImgHandler,
    private http: HttpClient,
    private uploadImagesService: UploadImagesService
  ) {
    var dateObj = new Date();
    var month = dateObj.getUTCMonth() + 1; //months from 1-12
    var day = dateObj.getUTCDate() + 1;
    var year = dateObj.getUTCFullYear();

    var today =   {year: year, month: month, day: day}

  
    dateObj.setMonth(dateObj.getMonth()+2);
    
    var month = dateObj.getUTCMonth() + 1; //months from 1-12
    var day = dateObj.getUTCDate() + 1;
    var year = dateObj.getUTCFullYear();

    var todayPlus2mo =   {year: year, month: month, day: day}

    this.minDate=today

    this.maxDate=todayPlus2mo
    
    this.searchKeyword.pipe(
      debounceTime(1000),
      distinctUntilChanged())
      .subscribe(value => {
        this.consoleMessages.push(value);
        console.log('vall :: ',value);
        if(value!==''){
          this.onsearchKeyword = true
          this.callSearch(value)
        } else {
          this.iconloading=false
          this.CategoryNotFound=false
          this.onsearchKeyword = false
        }
        
      });

  }

  ngOnInit(): void {

    this.EditRfqId = this.route.snapshot.paramMap.get('RfqId');
    console.log('RfqId',this.EditRfqId);
    if(this.EditRfqId){
      this.getDataEdit(this.EditRfqId)
    } else {
      console.log('EditRfqId is null');
      // this.addProduct() //add new w 1 empty product
      // check redirect from reccurring rfq
      if(this.checkDraftRfqForm()){

      }
      else if(this.checkRedirectReccurring()){

      } 
      else if(this.checkRepeatRfq()){

      }
      else if(this.checkCartListStorage()){
        
      }
      else {
        this.addProduct() //add new w 1 empty product
      }      


      //default 1 week
      var dateObj = new Date();
      dateObj.setDate(dateObj.getDate() + 30);
      var month = dateObj.getMonth() + 1; //months from 1-12
      var day = dateObj.getDate();
      var year = dateObj.getFullYear();
      var nextweek =   {year: year, month: month, day: day}
      this.ValsubmitQuotationLastDate=nextweek

      var dayplus30 = dateObj.setDate(dateObj.getDate() + 30);
      this.ValsubmitQuotationLastDatePreview =this.datepipe.transform(dayplus30, 'dd-MMM-yyyy');
    }


    this.subscription = this.data.currentMessage.subscribe(message => this.message = message)
    //alert(this.message)
    console.log('this.message',this.message);
    console.log('this.subscription',this.subscription);

    var test = Math.round(new Date().getTime() / 1000).toString()
    console.log('test',test)

    const unixTime = 1210981217;
    const date = new Date(unixTime*1000);
    var test2 = date.toLocaleDateString("en-US")
    console.log('test2',test2)

    this.getCountry()
    this.getCompanyLoc()



    this.countriesAddr = Getcountrycity.getAllCountry()
    this.dropdownSettings = {
      singleSelection: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      closeDropDownOnSelection: this.closeDropdownSelection
    }
    // load Indonesia cities by default
    var defaultCities = Getcountrycity.getCity('Indonesia')
    if(defaultCities){ this.cities = defaultCities }
    //this.getCategoryList()

    this.ValqtyUnit[0]='Pcs'

    if(localStorage.getItem("COMPANYSELECTID") !== null){
      // var getCompanyId = localStorage.getItem("COMPANYSELECTID");
      // this.ValcompanyLocationId=(getCompanyId)?getCompanyId:''
    } else {
      // this.authService.forceLogout();
      // this.router.navigate(['/login']);

    }


    const defaultCurrency = localStorage.getItem('defaultCurrency');

    if (defaultCurrency === null) {
      this.Valcurrency = "IDR"
    } else {
      this.Valcurrency = defaultCurrency
    }
    

    // for (let i = 0; i < this.MoreImgCount.length; i++) {
    //   this.imageSrcMore.push({ 'id': i, 'val': '', 'name': '' })
    // }

  }


  ngAfterViewInit(): void{
    if(this.selectedCat.length>0){
      this.ValrfqVendorCategory =  JSON.stringify(this.selectedCat)
    } else {
      this.ValrfqVendorCategory =  ''
    }

    this.cdRef.detectChanges(); 

  }

  get f() { return this.rfqForm?.controls; }

  onSubmit() {
    this.submitted = true

    console.log(this.rfqForm?.value)

    this.btnloading = true
    this.pageloading = true

    this.rfqFormInvalid=false

    var invalidform = 0

    console.log('this.productList.length',this.productList.length);
    this.emptyitem=false
    if(this.productList.length==0){
      this.emptyitem=true
      console.log('here invalidform++');
      invalidform++
    }

    console.log(this.rfqForm)
    if (this.rfqForm.invalid) {
      console.log('here invalidform++');
      invalidform++
    }

    // if(this.ValrfqItem==''){
    //   invalidform++
    // }

    this.productList.forEach((o: any, i: any) => {
      // if(this.Valname[i]==''|| !this.Valname[i]){
      //   console.log('here invalidform++');
      //   invalidform++
      // }

      if(this.Valdescription[i]==''|| !this.Valdescription[i]){
        console.log('here invalidform++');
        invalidform++
      }

      // if(this.Valbrand[i]==''|| !this.Valbrand[i]){
      //   invalidform++
      // }
      if(this.ValqtyNeeded[i]==''|| !this.ValqtyNeeded[i]){
        console.log('here invalidform++');
        invalidform++
      }
      if(this.ValqtyUnit[i]==''|| !this.ValqtyUnit[i]){
        console.log('here invalidform++');
        invalidform++
      }
      
      // if(this.ValmanufacturerSku[i]==''|| !this.ValmanufacturerSku[i]){
      //   invalidform++
      // }

      if(this.ValdescriptionProduct[i]==''|| !this.ValdescriptionProduct[i]){
        console.log('ValdescriptionProduct : ',this.ValdescriptionProduct[i]);
        console.log('here invalidform++');
        invalidform++
      }

    })

    if(invalidform>0){

      this.btnloading = false
      this.pageloading = false
      this.rfqFormInvalid=true
      console.log('invalid form');
      return;
    } else {

      this.btnloading = true
      this.pageloading = true
      this.rfqFormInvalid=false
      console.log('valid form');
    }
    console.log('rfqFormInvalid',this.rfqFormInvalid);


    this.productList.forEach((value: any, key: any) => {
      if(this.valspecLabel[key]!=='' || this.valspecValue[key]!==''){
        this.addSpec(key)
      }

    })

    
      for (let i = 0; i < this.valspecLabelErr.length; i++) {
        if(this.valspecLabelErr[i]==true) {
          this.btnloading = false
          this.pageloading = false
          this.rfqFormInvalid=true
          console.log('invalid valspecLabelErr');
          return;
        }
      }
      for (let i = 0; i < this.valspecValueErr.length; i++) {
        if(this.valspecValueErr[i]==true) {
          this.btnloading = false
          this.pageloading = false
          this.rfqFormInvalid=true
          console.log('invalid valspecValueErr');
          return;
        }
      }

    // if view RFQ

    if(this.actionbtn=='preview'){


      this.submitted = false
      this.btnloading = false
      this.pageloading = false

      //prepare data

      //var companyLocationId = this.ValcompanyLocationId
      var companyLocationId = this.ValCountry
      var description = this.Valdescription
      var submitQuotationLastDate = this.ValsubmitQuotationLastDate
      var paymentTermRequestedInDays = (this.ValpaymentTermRequestedInDays)?parseInt(this.ValpaymentTermRequestedInDays):null
      var etaRequested = this.ValetaRequested
      var currency = this.Valcurrency
      var procurementRefNumber = this.ValprocurementRefNumber
      var isForFullQuote = this.ValisForFullQuote
      var isIndentAccepted = this.ValisIndentAccepted
      var rfqItem = this.productList //this.ValrfqItem
      var rfqVendorCategory = this.selectedCat //this.ValrfqVendorCategory
      // var Country = this.ValCountry




      var lastsubmitYear = submitQuotationLastDate?.year
      var lastsubmitMonth = submitQuotationLastDate?.month -1 
      var lastsubmitDay = submitQuotationLastDate?.day

      console.log('lastsubmitMonth',lastsubmitMonth)

      var lastsubmitETA = new Date(lastsubmitYear, lastsubmitMonth, lastsubmitDay);

      var etaYear = etaRequested?.year
      var etaMonth = etaRequested?.month -1
      var etaDay = etaRequested?.day

      console.log('etaMonth',etaMonth)

      var dateETA = new Date(etaYear, etaMonth, etaDay);

      //remap date
      console.log('lastsubmitETA',lastsubmitETA)
      console.log('dateETA',dateETA)

      submitQuotationLastDate = Math.round(lastsubmitETA.getTime() / 1000).toString()
      etaRequested =  Math.round(dateETA.getTime() / 1000).toString()

      //remap rfq item

      // Valname:any=[]
      // Valbrand:any=[]
      // ValdescriptionProduct:any=[]
      // ValqtyNeeded:any=[]
      // ValmanufacturerSku:any=[]
      console.log('Valname',this.Valname);
      console.log('Valbrand',this.Valbrand);
      console.log('ValdescriptionProduct',this.ValdescriptionProduct);
      console.log('ValqtyNeeded',this.ValqtyNeeded);
      console.log('ValmanufacturerSku',this.ValmanufacturerSku);


      this.ArrRfqItem=[]
      var sequence = 1
      this.productList.forEach((obj: any, key: any) => {

        var descriptionWSpec = (!this.ValdescriptionProduct[key])?'<fhspecdiv>[]</fhspecdiv>':this.ValdescriptionProduct[key]

        if(this.valspecLabel[key] || this.valspecValue[key]){
          this.countarrFhSpec[key].push({label:this.valspecLabel[key],value:this.valspecValue[key]})
          this.valspecLabel[key] = ''
          this.valspecValue[key] = ''
        }

        if(this.countarrFhSpec[key].length>0){
          descriptionWSpec = this.ValdescriptionProduct[key]+"<fhspecdiv>"+ JSON.stringify(this.countarrFhSpec[key]) +"</fhspecdiv>"
        } else {
          descriptionWSpec = this.ValdescriptionProduct[key]+"<fhspecdiv>[]</fhspecdiv>"
        }


        // var arr = {
        //   name: this.Valname[key],
        //   brand: this.Valbrand[key],
        //   description: descriptionWSpec,
        //   qtyNeeded: parseInt(this.ValqtyNeeded[key]),
        //   manufacturerSku: this.ValmanufacturerSku[key],
        //   itemUnit:this.ValqtyUnit[key],
        //   itemSequence: sequence
        // }

        var arr:any = {}
        if(this.Valname[key]){ arr['name'] = this.Valname[key] }
        if(this.ValqtyNeeded[key]){ arr['qtyNeeded'] =parseInt(this.ValqtyNeeded[key]) }
        if(this.Valbrand[key]){ 
          arr['brand'] = this.Valbrand[key] 
        }

        arr['description'] = descriptionWSpec

        if(this.ValmanufacturerSku[key]){ arr['manufacturerSku'] = this.ValmanufacturerSku[key] }
        if(sequence){ arr['itemSequence'] = sequence }
        if(this.ValqtyUnit[key]){
          if(this.ValqtyUnit[key]!==''){
            arr['itemUnit'] = this.ValqtyUnit[key] 
          } else {
            arr['itemUnit'] = ''
          }
        } else {
          arr['itemUnit'] = ''
        }

        //add img 
        // imageSrcMore

        if(this.imageSrcMore[key]){ 
          var array_image:any = []
          if(this.imageSrcMore[key]){
            this.imageSrcMore[key].forEach((v:any,k:any) => {
              array_image.push(v.val)
            })
          }
          
          arr['fileName'] = array_image
        }


        this.ArrRfqItem.push(arr);
        sequence++
      });
      var rfqItem = this.ArrRfqItem
      console.log('rfqItem',rfqItem);


      console.log('imageSrcMore 123: ',this.imageSrcMore)
      console.log('ValfileName 123: ',this.ValfileName)
      console.log('CombineImgData 123: ',this.CombineImgData)

      //combine spec label value array with desc
      //var description = this.Valdescription+'<fhspecdiv>'+ JSON.stringify(this.countarrFhSpec) +'</fhspecdiv>'

      console.log('companyLocationId',companyLocationId);
      console.log('description',description);
      console.log('submitQuotationLastDate',submitQuotationLastDate);
      console.log('paymentTermRequestedInDays',paymentTermRequestedInDays);
      console.log('etaRequested',etaRequested);
      console.log('currency',currency);
      console.log('procurementRefNumber',procurementRefNumber);
      console.log('isForFullQuote',isForFullQuote);
      console.log('isIndentAccepted',isIndentAccepted);
      console.log('rfqItem',rfqItem);
      console.log('rfqVendorCategory',rfqVendorCategory);
      // console.log('Country',Country);



      var preparedata:any
      preparedata={
                    "id": "PREVIEW",
                    "companyLocation": {
                        "id": companyLocationId,
                        "label": this.ValCountryShow,
                        "country": this.ValCountryDetailarr.country,
                        "province":  this.ValCountryDetailarr.province,
                        "city": this.ValCountryDetailarr.province,
                        "street": this.ValCountryDetailarr.street,
                        "postalCode": this.ValCountryDetailarr.postalCode,
                        "phone": null,
                        "taxId": null,
                        "isMainAddress": false,
                        "__typename": "RfqCompanyLocation"
                    },
                    "state": "DRAFT",
                    "approvalStatus": 1,
                    "ongoingApprovalStatus": null,
                    "rfqDisplayId": "PREVDRAF",
                    "description": "<fhspecdiv>[]</fhspecdiv>",
                    "submitQuotationLastDate": lastsubmitETA,
                    "paymentTermRequestedInDays": paymentTermRequestedInDays,
                    "etaRequested": dateETA,
                    "currency": currency,
                    "procurementRefNumber": procurementRefNumber,
                    "isForFullQuote": isForFullQuote,
                    "isIndentAccepted": isIndentAccepted,
                    "expiredDate": "2022-01-24T17:00:00Z",
                    "rfqItem": rfqItem,
                    "rfqVendorCategory": rfqVendorCategory,
                    "totalVendorParticipation": 0,
                    "createdDate": "2021-12-17T02:31:42.000736Z",
                    "createdBy": "01FB6E45BM6AS1D93THRTM85J4",
                    "modifiedDate": "2022-01-24T17:00:01.961176Z",
                    "modifiedBy": "SYSTEM HALT",
                    "__typename": "Rfq"

      }


      // // this.data.changeMessage(val)
      // this.subscription = this.data.currentMessage.subscribe(message => this.message = JSON.stringify(preparedata))

      localStorage.setItem('RFQDRAFT', JSON.stringify(preparedata));
    

      //this.router.navigate(['/procurement/rfq/draft-mode/']);
      window.open('/procurement/rfq/draft-mode/', '_blank');
      
      //alert('redirect preview')
      return
    }
    

    this.SaveDraft()
  }

  addProduct(){
    if(this.productList.length!==0){
      //window.scrollTo(0,document.body.scrollHeight-(50/document.body.scrollHeight*100));
      //window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' })
      window.scrollTo(0,document.body.scrollHeight);
    }
    
    console.log('>addproduct');
    this.productList.forEach((value: any, key: any) => {
      this.productList[key]['collapse']=(this.EditRfqId)?true:false
      this.productList[key]['required']=true
    })
    this.loadingAddProduct=true
    setTimeout(()=> {
    this.productList.push({'collapse':true,'product':null,'required':true})
    this.loadingAddProduct=false
    }
    ,700);
    // this.productList.push({'collapse':true,'product':null,'required':true})
    console.log('this.productList',this.productList);


    //desc detail
    this.countarrFhSpec.push([])
    this.valspecLabel.push('')
    this.valspecValue.push('')
    this.ValSpecEmpty.push(false)
    this.valspecValueErr.push(false)
    this.valspecLabelErr.push(false)
    this.emptyLabelSpec.push([{error:false}])
    this.emptyValueSpec.push([{error:false}])

    this.ValqtyUnit.push('Pcs')
    //window.scrollTo(0,document.body.scrollHeight);
  
  }
  AccordionHideShow(i:any){

    console.log('--------------');

    if(this.productList[i]['collapse']==true){
      this.productList[i]['collapse']=false
    } else {
      this.productList[i]['collapse']=true
    }
    console.log('to',this.productList);
    console.log('--------------');
  }

  // AccordionHideShow(i:any){


  //   console.log('--------------');
  //   console.log('from',this.accordionStatus);
  //   console.log('i',i);

  //   if(this.accordionStatus.length>0){
  //     if(this.accordionStatus[i]==true){
  //       this.accordionStatus[i]=false
  //     } else {
  //       this.accordionStatus[i]=true
  //     }
  //   } else {
  //     this.accordionStatus[i]=true;
  //   }

  //   // if(this.accordionStatus.length>0){
  //   //   this.accordionStatus.forEach((value: any, key: any) => {
  //   //     console.log('i',i);
  //   //     console.log('value.label',value.label);
  //   //     if(value.label==i){
  //   //       console.log('exist, change value');
  //   //       this.accordionStatus[key]['value']=false
  //   //     } else {
  //   //       console.log('ga exist, push');
  //   //       this.accordionStatus.push({'label':i,'value':true})
  //   //     }
  //   //   })
  //   // } else {
  //   //   console.log('emptydata, push first');
  //   //   this.accordionStatus.push({'label':i,'value':true})
  //   // }




  //   // if(this.accordionStatus){
  //   //   console.log('AccordionHideShow show')
  //   //   this.accordionStatus=true
  //   // } else {
  //   //   console.log('AccordionHideShow hide')
  //   //   this.accordionStatus=false
  //   // }
  //   console.log('to',this.accordionStatus);
  //   console.log('--------------');
  // }

  SubmitData()
  {

    console.log('productForm validd');



    //var companyLocationId = this.ValcompanyLocationId
    var companyLocationId = this.ValCountry
    var description = this.Valdescription
    var submitQuotationLastDate = this.ValsubmitQuotationLastDate
    var paymentTermRequestedInDays = (this.ValpaymentTermRequestedInDays)?parseInt(this.ValpaymentTermRequestedInDays):null
    var etaRequested = this.ValetaRequested
    var currency = this.Valcurrency
    var procurementRefNumber = this.ValprocurementRefNumber
    var isForFullQuote = this.ValisForFullQuote
    var isIndentAccepted = this.ValisIndentAccepted
    var rfqItem = this.productList //this.ValrfqItem
    var rfqVendorCategory = this.selectedCat //this.ValrfqVendorCategory
    // var Country = this.ValCountry




    var lastsubmitYear = submitQuotationLastDate?.year
    var lastsubmitMonth = submitQuotationLastDate?.month -1 
    var lastsubmitDay = submitQuotationLastDate?.day

    console.log('lastsubmitMonth',lastsubmitMonth)

    var lastsubmitETA = new Date(lastsubmitYear, lastsubmitMonth, lastsubmitDay);

    var etaYear = etaRequested?.year
    var etaMonth = etaRequested?.month -1
    var etaDay = etaRequested?.day

    console.log('etaMonth',etaMonth)

    var dateETA = new Date(etaYear, etaMonth, etaDay);

    //remap date
    console.log('lastsubmitETA',lastsubmitETA)
    console.log('dateETA',dateETA)

    submitQuotationLastDate = Math.round(lastsubmitETA.getTime() / 1000).toString()
    etaRequested =  Math.round(dateETA.getTime() / 1000).toString()

    //remap rfq item

    // Valname:any=[]
    // Valbrand:any=[]
    // ValdescriptionProduct:any=[]
    // ValqtyNeeded:any=[]
    // ValmanufacturerSku:any=[]
    console.log('Valname',this.Valname);
    console.log('Valbrand',this.Valbrand);
    console.log('ValdescriptionProduct',this.ValdescriptionProduct);
    console.log('ValqtyNeeded',this.ValqtyNeeded);
    console.log('ValmanufacturerSku',this.ValmanufacturerSku);


    this.ArrRfqItem=[]
    var sequence = 1
    this.productList.forEach((obj: any, key: any) => {

      var descriptionWSpec = (!this.ValdescriptionProduct[key])?'<fhspecdiv>[]</fhspecdiv>':this.ValdescriptionProduct[key]
      if(this.countarrFhSpec[key].length>0){
        descriptionWSpec = this.ValdescriptionProduct[key]+"<fhspecdiv>"+ JSON.stringify(this.countarrFhSpec[key]) +"</fhspecdiv>"
      } else {
        descriptionWSpec = this.ValdescriptionProduct[key]+"<fhspecdiv>[]</fhspecdiv>"
      }


      // var arr = {
      //   name: this.Valname[key],
      //   brand: this.Valbrand[key],
      //   description: descriptionWSpec,
      //   qtyNeeded: parseInt(this.ValqtyNeeded[key]),
      //   manufacturerSku: this.ValmanufacturerSku[key],
      //   itemUnit:this.ValqtyUnit[key],
      //   itemSequence: sequence
      // }

      var arr:any = {}
      if(this.Valname[key]){ arr['name'] = this.Valname[key] }
      if(this.ValqtyNeeded[key]){ arr['qtyNeeded'] =parseInt(this.ValqtyNeeded[key]) }
      if(this.Valbrand[key]){ 
        arr['brand'] = this.Valbrand[key] 
      }

      arr['description'] = descriptionWSpec

      if(this.ValmanufacturerSku[key]){ arr['manufacturerSku'] = this.ValmanufacturerSku[key] }
      if(sequence){ arr['itemSequence'] = sequence }
      if(this.ValqtyUnit[key]){
        if(this.ValqtyUnit[key]!==''){
          arr['itemUnit'] = this.ValqtyUnit[key] 
        } else {
          arr['itemUnit'] = ''
        }
      } else {
        arr['itemUnit'] = ''
      }

      //set upload images
      var imgData:any = []
      if(this.imageSrcMore[key]){
        var imgName = 1
        for(let x=0; x < this.imageSrcMore[key].length;x++){
          if(this.imageSrcMore[key][x].name){
            imgData.push(''+imgName+'.jpg')
            imgName++
          }
        }
        arr['fileName'] = imgData
      } else {
        arr['fileName'] = imgData
      }
      

      this.ArrRfqItem.push(arr);
      sequence++
    });
    var rfqItem = this.ArrRfqItem
    console.log('rfqItem',rfqItem);


    //combine spec label value array with desc
    //var description = this.Valdescription+'<fhspecdiv>'+ JSON.stringify(this.countarrFhSpec) +'</fhspecdiv>'

    console.log('companyLocationId',companyLocationId);
    console.log('description',description);
    console.log('submitQuotationLastDate',submitQuotationLastDate);
    console.log('paymentTermRequestedInDays',paymentTermRequestedInDays);
    console.log('etaRequested',etaRequested);
    console.log('currency',currency);
    console.log('procurementRefNumber',procurementRefNumber);
    console.log('isForFullQuote',isForFullQuote);
    console.log('isIndentAccepted',isIndentAccepted);
    console.log('rfqItem',rfqItem);
    console.log('rfqVendorCategory',rfqVendorCategory);
    // console.log('Country',Country);


    this.successResponse=false;
    this.successResponseName=''


    
    // ReqType      : 'query' / 'mutation' 
    // ReqName      : ex :: rfqList / insertRfq / etc..
    // ArrParams    : ex :: { 'param':'companyLocationId', 'value':'01F84XE4F2MJY046GT19CBW15W', 'type':'ID!' }
    // Res          : ex :: '__typename,      ...on CompanyProduct {id          name          brand    description'   
    var ReqType = 'mutation'
    var ReqName = 'insertRfq'
    var ArrParams = []


    ArrParams.push({'param':'companyLocationId','value': this.ValCountry,'type':'ID!'})

    //if(this.Valdescription!==''){
      ArrParams.push({'param':'description','value': this.Valdescription,'type':'String!'})
    //} 
    if(submitQuotationLastDate>0){
      ArrParams.push({'param':'submitQuotationLastDate','value': submitQuotationLastDate,'type':'String!'})
    } 
    if(paymentTermRequestedInDays){
      ArrParams.push({'param':'paymentTermRequestedInDays','value': this.ValpaymentTermRequestedInDays,'type':'Int!'})
    } 
    if(this.ValetaRequested){
      ArrParams.push({'param':'etaRequested','value': etaRequested,'type':'String!'})
    } 
    if(this.Valcurrency!==''){
      ArrParams.push({'param':'currency','value': this.Valcurrency,'type':'String!'})
    }
    if(this.ValprocurementRefNumber!==''){
      ArrParams.push({'param':'procurementRefNumber','value': this.ValprocurementRefNumber,'type':'String'})
    }

    ArrParams.push({'param':'isForFullQuote','value': this.ValisForFullQuote,'type':'Boolean!'})
    ArrParams.push({'param':'isIndentAccepted','value': this.ValisIndentAccepted,'type':'Boolean!'})

    ArrParams.push({'param':'rfqItem','value': rfqItem,'type':'[RfqItemInput!]!'})
    
    if(this.ValrfqVendorCategory!==''){
      ArrParams.push({'param':'rfqVendorCategory','value': this.selectedCat,'type':'[String!]'})
    }  


      // $companyLocationId: ID!, $description: String!, $submitQuotationLastDate: String!, $paymentTermRequestedInDays: Int!, $etaRequested: String!, $currency: String!, $procurementRefNumber: String!, $isForFullQuote: Boolean!, $isIndentAccepted: Boolean!, $rfqItem: [RfqItemInput!]!, $rfqVendorCategory: [String!]



    var Res = 'id companyLocation {     id     label     country     province     city     street     postalCode     phone     taxId     isMainAddress } state approvalStatus ongoingApprovalStatus rfqDisplayId description, submitQuotationLastDate paymentTermRequestedInDays etaRequested currency procurementRefNumber isForFullQuote isIndentAccepted expiredDate rfqItem {     id     name     brand     description     qtyNeeded     manufacturerSku     itemSequence     itemUnit } rfqVendorCategory {     id     category } createdDate createdBy modifiedDate modifiedBy'
    var PostRfqData = Util.setQueryGQL(ReqType,ReqName,ArrParams,Res)
    console.log('PostRfqData',PostRfqData[0].gql);
    console.log('PostRfqData',PostRfqData[1].variable);

    console.log('ArrParams',ArrParams);
    // alert('post create data');
    // return;

    this.SuccessInsertorUpdate = null
    this.apollo
      .mutate({
        //mutation: postRfq,
        mutation: gql`${PostRfqData[0].gql}`,
        // variables: {
        //   companyLocationId: companyLocationId,
        //   description: description,
        //   submitQuotationLastDate: submitQuotationLastDate,
        //   paymentTermRequestedInDays: paymentTermRequestedInDays,
        //   etaRequested: etaRequested,
        //   currency: currency,
        //   procurementRefNumber: procurementRefNumber,
        //   isForFullQuote: isForFullQuote,
        //   isIndentAccepted: isIndentAccepted,
        //   rfqItem: rfqItem,
        //   rfqVendorCategory: rfqVendorCategory,
        //   // Country: Country
        // }
        variables: PostRfqData[1].variable
      })
      .subscribe(
        (res:any) => {
          console.log("succes, get data:", res);
          if(res.data){


            this.SuccessInsertorUpdate = res.data



            //this.successregistration=true;
            //alert('Success add product.');
            this.successResponse=true;
            this.successResponseName= 'Product <strong>'+res.data.insertRfq.rfqDisplayId+'</strong> added successfully.'

            this.EditRfqId =res.data.insertRfq.id
            // if(this.actionbtn=='draft'){
            //   //draft
            //   this.successdraft = true
            //   window.scroll(0,0)

            //   this.openmodaldraft()
            // }
            // else if (this.actionbtn=='preview'){
            //   //preivew
            //   this.openmodaldraft()
            // }
            // else {
            //   //done
            //   this.openmodaldone()
            //   this.resetData()
            // }

            this.postUpdateImage('add')

          }
          else {
            //alert('Failed, please try again later.');
            this.popupmodal.showError('Failed, please try again later.',null).subscribe((res:any) => {})

          }
          //this.pageloading=false;

        },
        error => {
          console.log("there was an error sending the query", error);

          // const errorLink = onError(({ networkError }) => {
          //   const networkErrorRef:HttpErrorResponse = networkError as HttpErrorResponse;
          //   if (networkErrorRef && networkErrorRef.status === 401) {
          //     console.log('Going to login page...');
          //   }
          // });
          // console.log(errorLink)

          onError(({ graphQLErrors, networkError }) => {
            if (graphQLErrors)
              graphQLErrors.map(({ message, locations, path }) =>
                console.log(
                  `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`,
                ),
              );

            if (networkError) console.log(`[Network error]: ${networkError}`);
          });


          // }
          //alert('Oops.. Something went wrong.');

          var errMsg = error + '';
          var res = errMsg.split(":");
          var resMsg = res[res.length - 1];
          var msg = (resMsg)? resMsg: errMsg
          //alert(msg)
          this.popupmodal.showError(msg,null).subscribe((res:any) => {})
          //this.pageloading=false;
        }
      );


    this.btnloading = false
    this.pageloading = false
    console.log('SubmitData')
  }
  SaveDraft()
  {
    // rebuild ArrRfqItem from current form state before saving
    this.ArrRfqItem = []
    this.productList.forEach((obj: any, key: any) => {
      const arr: any = {}
      if (this.Valname[key]) arr['name'] = this.Valname[key]
      if (this.ValqtyNeeded[key]) arr['qtyNeeded'] = this.ValqtyNeeded[key]
      if (this.Valbrand[key]) arr['brand'] = this.Valbrand[key]
      if (this.ValmanufacturerSku[key]) arr['manufacturerSku'] = this.ValmanufacturerSku[key]
      arr['itemUnit'] = this.ValqtyUnit[key] || ''
      arr['itemSequence'] = key + 1

      // merge committed specs + pending input field into description
      const specsArr = [...(this.countarrFhSpec[key] || [])]
      if (this.valspecLabel[key] || this.valspecValue[key]) {
        specsArr.push({ label: this.valspecLabel[key], value: this.valspecValue[key] })
      }
      const baseDesc = this.ValdescriptionProduct[key] || ''
      arr['description'] = baseDesc + '<fhspecdiv>' + JSON.stringify(specsArr) + '</fhspecdiv>'

      this.ArrRfqItem.push(arr)
    })

    // ngAutonumeric can emit 0 on re-init; fall back to previous value if current is falsy
    const paymentTerm = (this.ValpaymentTermRequestedInDays && parseFloat(this.ValpaymentTermRequestedInDays) > 0)
      ? parseFloat(this.ValpaymentTermRequestedInDays)
      : (this.ValpaymentTermRequestedInDaysPrev || null)

    const draftData = {
      companyLocationId: this.ValCountry,
      companyLocationLabel: this.ValCountryShow,
      companyLocationDetail: this.ValCountryDetailarr,
      description: this.Valdescription,
      submitQuotationLastDate: this.ValsubmitQuotationLastDate,
      paymentTermRequestedInDays: paymentTerm,
      etaRequested: this.ValetaRequested,
      currency: this.Valcurrency,
      procurementRefNumber: this.ValprocurementRefNumber,
      isForFullQuote: this.ValisForFullQuote,
      isIndentAccepted: this.ValisIndentAccepted,
      rfqItem: this.ArrRfqItem,
      rfqVendorCategory: this.selectedCat,
      productList: this.productList,
      imageSrcMore: this.imageSrcMore.map((arr: any[]) =>
        arr ? arr.map((img: any) => ({ val: img.val, name: img.name, rfqItemId: img.rfqItemId })) : []
      ),
      savedAt: new Date().toISOString()
    }
    localStorage.setItem('DRAFT_RFQ_FORM', JSON.stringify(draftData))

    this.btnloading = false
    this.pageloading = false
    this.openEmailDraftModal()
  }

  openEmailDraftModal(){
    this.ValDraftEmail = localStorage.getItem('DRAFT_RFQ_EMAIL') || ''
    this.emailDraftSubmitted = false
    this.emailDraftModal = 'block'
  }

  closeEmailDraftModal(){
    this.emailDraftModal = 'none'
  }

  submitEmailDraft(){
    this.emailDraftSubmitted = true
    if(!this.ValDraftEmail || !this.ValDraftEmail.includes('@')){
      return
    }
    localStorage.setItem('DRAFT_RFQ_EMAIL', this.ValDraftEmail)

    const draft = JSON.parse(localStorage.getItem('DRAFT_RFQ_FORM') || '{}')

    // convert NgbDateStruct to unix timestamp strings
    const toUnix = (d: any): string => {
      if(!d) return ''
      const dt = new Date(d.year, (d.month - 1), d.day)
      return Math.round(dt.getTime() / 1000).toString()
    }

    const rfqItems = (draft.rfqItem || []).map((item: any) => ({
      description:    item.description    || '',
      qtyNeeded:      item.qtyNeeded      ? parseInt(item.qtyNeeded) : 0,
      itemSequence:   item.itemSequence   || 1,
      itemUnit:       item.itemUnit       || '',
      ...(item.name            && { name: item.name }),
      ...(item.brand           && { brand: item.brand }),
      ...(item.manufacturerSku && { manufacturerSku: item.manufacturerSku })
    }))

    const mutation = gql`
      mutation SaveRfqRegistration(
        $email: String!
        $locationDataInput: LocationDataInput!
        $etaRequested: String
        $submitQuotationLastDate: String!
        $paymentTermRequestedInDays: Int
        $currency: String!
        $isForFullQuote: Boolean!
        $isIndentAccepted: Boolean!
        $rfqRegistrationItemInput: [RfqRegistrationItemInput!]!
      ) {
        saveRfqRegistration(input: {
          email: $email
          locationDataInput: $locationDataInput
          etaRequested: $etaRequested
          submitQuotationLastDate: $submitQuotationLastDate
          paymentTermRequestedInDays: $paymentTermRequestedInDays
          currency: $currency
          isForFullQuote: $isForFullQuote
          isIndentAccepted: $isIndentAccepted
          rfqRegistrationItemInput: $rfqRegistrationItemInput
        }) {
          isEmailExist
          isSuccessSave
        }
      }
    `

    this.emailDraftLoading = true

    // fall back to PENDING_ADDRESS[0] if no location was selected in-session
    const locDetail = (this.ValCountryDetailarr?.country)
      ? this.ValCountryDetailarr
      : (JSON.parse(localStorage.getItem('PENDING_ADDRESS') || '[]')[0] || {})

    this.apollo.mutate({
      mutation,
      variables: {
        email:                      this.ValDraftEmail,
        locationDataInput: {
          country:    locDetail.country    || '',
          province:   locDetail.province   || '',
          city:       locDetail.city       || '',
          street:     locDetail.street     || '',
          postalCode: locDetail.postalCode || ''
        },
        ...(draft.etaRequested && { etaRequested: toUnix(draft.etaRequested) }),
        submitQuotationLastDate:    toUnix(draft.submitQuotationLastDate),
        paymentTermRequestedInDays: draft.paymentTermRequestedInDays ? parseInt(draft.paymentTermRequestedInDays) : null,
        currency:                   draft.currency       || 'IDR',
        isForFullQuote:             draft.isForFullQuote  ?? false,
        isIndentAccepted:           draft.isIndentAccepted ?? true,
        rfqRegistrationItemInput:   rfqItems
      }
    }).subscribe(
      (res: any) => {
        this.emailDraftLoading = false
        const result = res?.data?.saveRfqRegistration
        if(!result) {
          this.popupmodal.showError('Terjadi kesalahan, silakan coba lagi.', null).subscribe()
          return
        }
        this.emailDraftModal = 'none'
        if(result.isEmailExist) {
          this.router.navigate(['/login'], { queryParams: { pov: 'PROCUREMENT' } })
        } else {
          this.router.navigate(['/regis'], { queryParams: { pov: 'PROCUREMENT' } })
        }
      },
      (error: any) => {
        this.emailDraftLoading = false
        const errMsg = error + ''
        const parts = errMsg.split(':')
        const msg = parts[parts.length - 1]?.trim() || errMsg
        this.popupmodal.showError(msg, null).subscribe()
      }
    )
  }


  successModalInsert(){
    const modalRef = this.modalService.open(ModalComponent, {
      modalDialogClass: 'modal-dialog-centered div-modal-content',
      centered: true,
      size: 'md'
    })

    var titleNotif = 'Success'
    var descNotif = 'Success saved data!'
    var redirectNotif ='/procurement/rfq-list'
    var textBtn = 'Done'

    if(this.actionbtn=='draft' || this.actionbtn=='preview'){
      if(this.actionbtn=='draft'){
        this.successdraft = true
        window.scroll(0,0)
      }
      descNotif = 'Your data has been successfully saved as a draft!'
      redirectNotif = '/procurement/rfq/edit/'+this.EditRfqId
      textBtn = 'CLOSE'
    } 
    else if(this.actionbtn=='done'){
      descNotif = 'Your data has been successfully saved!'
      redirectNotif = '/procurement/rfq/detail/'+this.EditRfqId
      textBtn = 'DONE'
      this.resetData()
    }

    modalRef.componentInstance.modalinfo = 'info'
    modalRef.componentInstance.infoTitle = titleNotif
    modalRef.componentInstance.infoSuccess = descNotif
    modalRef.componentInstance.infoFailed = null
    modalRef.componentInstance.closeTxt = textBtn

    modalRef.componentInstance.confirmedClick.subscribe((res: any) => {
      if (res){
        this.router.navigate([redirectNotif]);
      } 
    })

  }

  successModalUpdate(){
    const modalRef = this.modalService.open(ModalComponent, {
      modalDialogClass: 'modal-dialog-centered div-modal-content',
      centered: true,
      size: 'md'
    })

    var titleNotif = 'Success'
    var descNotif = 'Success saved data!'
    var redirectNotif ='/procurement/rfq-list'
    var textBtn = 'Done'

    if(this.actionbtn=='draft' || this.actionbtn=='preview'){
      if(this.actionbtn=='draft'){
        this.successdraft = true
        window.scroll(0,0)
      }
      descNotif = 'Your data has been successfully saved as a draft!'
      redirectNotif = '/procurement/rfq/edit/'+this.EditRfqId
      textBtn = 'CLOSE'
    } 
    else if(this.actionbtn=='done'){
      descNotif = 'Your data has been successfully saved!'
      redirectNotif = '/procurement/rfq/detail/'+this.EditRfqId
      textBtn = 'DONE'
      this.resetData()
    }

    modalRef.componentInstance.modalinfo = 'info'
    modalRef.componentInstance.infoTitle = titleNotif
    modalRef.componentInstance.infoSuccess = descNotif
    modalRef.componentInstance.infoFailed = null
    modalRef.componentInstance.closeTxt = textBtn

    modalRef.componentInstance.confirmedClick.subscribe((res: any) => {
      if (res){
        this.router.navigate([redirectNotif]);
      } 
    })

  }

  //img url to base64
  toDataURL(url:string, callback:any) {
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
        var reader = new FileReader();
        reader.onloadend = function () {
            callback(reader.result);
        }
        reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
  }



  submitaction(val:any){
    this.successdraft = false
    window.scroll(0,0)
    this.actionbtn = ''
    this.actionbtn = val
    this.onSubmit()
  }
  closesuccessdraft(){
    this.successdraft = false
  }

  back(): void {
    this.router.navigate(['/procurement/rfq-list']);
    //this.navigation.back()
  }

  getCountry(){
    this.apollo.watchQuery<any>({
      query: getcountry,
      errorPolicy: 'all'
    })
    .valueChanges
    .subscribe(({data, loading}) => {
      console.log(loading);
      console.log('getcountry',data);
      this.countries = data.registrationPage.countryItem;
      console.log('xxx',this.countries);
    })
  }

  get g() { return this.AddressForm?.controls; }

  openAddAddressModal(){
    this.addresssubmitted = false
    this.Vallabel = ''
    this.Valcountry = ['Indonesia']
    this.Valprovince = ''
    this.Valcity = ''
    this.Valstreet = ''
    this.ValpostalCode = ''
    this.Valphone = ''
    this.ValtaxId = ''
    this.ValisMainAddress = false
    var defaultCities = Getcountrycity.getCity('Indonesia')
    if(defaultCities){ this.cities = defaultCities }
    this.addAddressModal = 'block'
  }

  closeAddAddressModal(){
    this.addAddressModal = 'none'
  }

  onItemSelectCountryAddr(item: any){
    if(Getcountrycity.getCity(item)){
      this.cities = Getcountrycity.getCity(item)
      this.Valcity = ''
    }
  }

  onItemDeselectCountryAddr(item: any){
    this.Valcity = ''
  }

  onItemSelectCityAddr(item: any){
    this.Valcity[0] = item
  }

  onSubmitAddress(){
    this.addresssubmitted = true
    if(this.AddressForm.invalid){ return }

    const pending = {
      label:          this.Vallabel,
      country:        this.Valcountry[0],
      province:       this.Valprovince,
      city:           Array.isArray(this.Valcity) ? this.Valcity[0] : this.Valcity,
      street:         this.Valstreet,
      postalCode:     this.ValpostalCode,
      phone:          this.Valphone,
      taxId:          this.ValtaxId,
      isMainAddress:  this.ValisMainAddress
    }

    // persist to localStorage; will be posted to API after login
    const existing = JSON.parse(localStorage.getItem('PENDING_ADDRESS') || '[]')
    existing.push(pending)
    localStorage.setItem('PENDING_ADDRESS', JSON.stringify(existing))

    // optimistically add to the location dropdown so user can select it
    const tempLoc = {
      id:         'PENDING_' + Date.now(),
      label:      pending.label,
      country:    pending.country,
      province:   pending.province,
      city:       pending.city,
      street:     pending.street,
      postalCode: pending.postalCode,
      isPending:  true
    }
    this.getCompanyLocation = [...(this.getCompanyLocation || []), tempLoc]
    this.selectShipTo(tempLoc)

    this.addresssubmitted = false
    this.addAddressModal = 'none'
  }

  removeAddress(loc: any){
    this.getCompanyLocation = this.getCompanyLocation.filter((l: any) => l.id !== loc.id)
    const existing = JSON.parse(localStorage.getItem('PENDING_ADDRESS') || '[]')
    const updated = existing.filter((a: any) => a.label !== loc.label || a.street !== loc.street)
    localStorage.setItem('PENDING_ADDRESS', JSON.stringify(updated))
    if(this.ValCountry === loc.id){
      this.ValCountry = ''
      this.ValCountryShow = 'Select Location'
    }
  }

  getCompanyLoc(){
      const pendingRaw = localStorage.getItem('PENDING_ADDRESS')
      const pendingLocs = pendingRaw ? JSON.parse(pendingRaw).map((a: any) => ({
        id:        'PENDING_' + a.label + '_' + a.street,
        label:     a.label,
        country:   a.country,
        province:  a.province,
        city:      a.city,
        street:    a.street,
        isPending: true
      })) : []
      this.getCompanyLocation = [...pendingLocs]
      console.log('xxx',this.getCompanyLocation);
  }


  onCheckisForFullQuote(check: any){
    if(check.target.checked){
      console.log('onCheckisForFullQuote checked')
      this.ValisForFullQuote=true
    } else {
      console.log('onCheckisForFullQuote unchecked')
      this.ValisForFullQuote=false
    }
  }

  onCheckisIndentAccepted(check: any){
    if(check.target.checked){
      console.log('onCheckisIndentAccepted checked')
      this.ValisIndentAccepted=true
    } else {
      console.log('onCheckisIndentAccepted unchecked')
      this.ValisIndentAccepted=false
    }
  }

  removeProduct(i:any){
    this.productList.splice(i,1)

    this.Valname.splice(i,1)
    this.ValqtyNeeded.splice(i,1)
    this.ValmanufacturerSku.splice(i,1)
    this.Valbrand.splice(i,1)
    this.ValdescriptionProduct.splice(i,1)
    this.ValqtyUnit.splice(i,1)
    this.ValqtyNeededPrev.splice(i,1)
    
    this.valspecLabel.splice(i,1)
    this.valspecValue.splice(i,1)
    this.countarrFhSpec.splice(i,1)

    // call /draftremove for each attached image before removing from state
    const imgsToRemove: any[] = (this.imageSrcMore[i] || []).filter((img: any) => img?.val)
    imgsToRemove.forEach((img: any) => {
      const urlPath = img.val.replace(/^https?:\/\/[^\/]+/, '')
      this.http.post<any>('/draftremove', { url: urlPath }).subscribe({
        error: (err: any) => { console.error('Remove image on delete product failed', err) }
      })
    })

    this.imageSrcMore.splice(i, 1);
    this.saveDraftImages()

    // this.Valname[i] = ''
    // this.ValqtyNeeded[i] = null
    // this.ValmanufacturerSku[i] = ''
    // this.Valbrand[i] = ''
    // this.ValdescriptionProduct[i] = null
    // this.ValqtyUnit[i] = null
    //this.countarrFhSpec = []
  }

  MoreImgRemoveFile(id:any, itemIndex:number){
    const img = this.imageSrcMore[itemIndex] && this.imageSrcMore[itemIndex][id]
    const urlToRemove = img ? img.val : null

    this.imageSrcMore[itemIndex].splice(id, 1);
    console.log('imageSrcMore : ',this.imageSrcMore)

    this.ValimageMoreText[itemIndex]=[]
    this.ArrResizeImage[itemIndex]=null

    if (urlToRemove) {
      const urlPath = urlToRemove.replace(/^https?:\/\/[^\/]+/, '')
      this.http.post<any>('/draftremove', { url: urlPath }).subscribe({
        next: () => { this.saveDraftImages() },
        error: (err: any) => { console.error('Remove image failed', err); this.saveDraftImages() }
      })
    } else {
      this.saveDraftImages()
    }
  }

  saveDraftImages() {
    const saved = localStorage.getItem('DRAFT_RFQ_FORM')
    if (!saved) { return }
    const draft = JSON.parse(saved)
    draft.imageSrcMore = this.imageSrcMore.map((arr: any[]) =>
      arr ? arr.map((img: any) => ({ val: img.val, name: img.name, rfqItemId: img.rfqItemId })) : []
    )
    localStorage.setItem('DRAFT_RFQ_FORM', JSON.stringify(draft))
  }

  MoreImgFileClick(id:any){
    console.log('id',id);
    let element:HTMLElement = document.getElementById(id) as HTMLElement;
    console.log(element);
    element.click();
  }
  removePirmaryImg(){
    this.imageSrc =''
    this.ValimageFileName=''
  }

  addSpec(seq:any){
    if(this.valspecLabel[seq]==''||!this.valspecLabel[seq]){
      this.valspecLabelErr[seq] = true
    } else {
      this.valspecLabelErr[seq] = false
    }
    if(this.valspecValue[seq]==''||!this.valspecValue[seq]){
      this.valspecValueErr[seq] = true
    } else {
      this.valspecValueErr[seq] = false
    }


    if(( (this.valspecLabel[seq]==''||!this.valspecLabel[seq]) && (this.valspecValue[seq]==''||!this.valspecValue[seq])) || ((this.valspecLabel[seq]==''||!this.valspecLabel[seq]) || (this.valspecValue[seq]==''||!this.valspecValue[seq])) ){
      this.ValSpecEmpty[seq]=true
    }

    if((this.valspecLabel[seq]!=='' || this.valspecLabel[seq] ) && (this.valspecValue[seq]!==''|| this.valspecValue[seq])){
      this.countarrFhSpec[seq].push({label:this.valspecLabel[seq],value:this.valspecValue[seq]})
      this.valspecValue[seq]=''
      this.valspecLabel[seq]=''
      this.valspecLabelErr[seq] = false
      this.valspecValueErr[seq] = false

      this.emptyLabelSpec[seq].push({error:false})
      this.emptyValueSpec[seq].push({error:false})

      this.ValSpecEmpty[seq]=false
    }

  }
  clearSpec(seq:any){
    this.valspecLabelErr[seq]=false
    this.valspecValueErr[seq]=false
    this.ValSpecEmpty[seq]=false
    this.valspecValue[seq]=''
    this.valspecLabel[seq]=''
  }

  firstLabelSpec(seq:any,val:any){
    if(val?.target.value !==''){
      this.valspecLabelErr[seq]=false
    } else {
      this.valspecLabelErr[seq]=true
    }
    this.ValSpecEmpty[seq]=true
  }
  firstValueSpec(seq:any,val:any){
    if(val?.target.value !==''){
      this.valspecValueErr[seq]=false
    } else {
      this.valspecValueErr[seq]=true
    }
    this.ValSpecEmpty[seq]=true
  }

  removeSpec(seq:any,i:any){
    console.log('removeSpec:: ',i)
    var index: number = this.countarrFhSpec[seq].indexOf(i);
    if (index !== -1) {
        this.countarrFhSpec[seq].splice(index, 1);

        this.emptyLabelSpec[seq].splice(index, 1)
        this.emptyValueSpec[seq].splice(index, 1)
    }


    console.log('countarrFhSpec remove:: ',this.countarrFhSpec)
  }
  changeValueSpec(seq:any,i:any,val:any){
    console.log('changeValueSpec:: ',i)

    var index: number = this.countarrFhSpec[seq].indexOf(i);
    if(val?.target.value !==''){
      this.emptyValueSpec[seq][index].error=false
    } else {
      this.emptyValueSpec[seq][index].error=true
    }

    this.countarrFhSpec[seq].forEach((obj: any, key: any) => {
      if(key==index){
        console.log('>>',obj);
        this.countarrFhSpec[seq][key].value=val?.target.value
      }
    });

  }

  changeLabelSpec(seq:any,i:any,val:any){
    console.log('changeLabelSpec:: ',i)
    console.log('val:: ',val?.target.value)

    var index: number = this.countarrFhSpec[seq].indexOf(i);

    if(val?.target.value !==''){
      this.emptyLabelSpec[seq][index].error=false
    } else {
      this.emptyLabelSpec[seq][index].error=true
    }

    this.countarrFhSpec[seq].forEach((obj: any, key: any) => {
      if(key==index){
        console.log('>>',obj);
        this.countarrFhSpec[seq][key].label=val?.target.value
      }
    });



  }



  onItemSelect(item: any) {
    console.log(item);

    this.selectedItemsTag.push(item)
    console.log(this.selectedItemsTag);
  }

  onItemDeSelect(item: any) {
    console.log(item);

    this.selectedItemsTag.forEach((obj: any, key: any) => {
      if(obj.id==item.item_id){
        this.selectedItemsTag.splice(key, 1);
      }
    });
    console.log(this.selectedItemsTag);
  }

  onSelectAll(items: any) {
    console.log(items);

    this.selectedItemsTag = items
    console.log(this.selectedItemsTag);
  }

  onDeselectAll(items: any) {
    console.log(items);

    this.selectedItemsTag = []
    console.log(this.selectedItemsTag);
  }

  onChangeTag(val: any,check: any){
    console.log('onChangeTag',val)
    console.log('check',check)
    if(check.target.checked){
      this.SelectedTags.push(val)
    } else {
      const index: number = this.SelectedTags.indexOf(val);
      this.SelectedTags.splice(index, 1);
    }
    console.log('this.tags',this.SelectedTags);
  }

  closerfqFormInvalid(){
    this.rfqFormInvalid=false
  }

  modalCategory(){
    (this.modalCategories) ? this.modalCategories=false : this.modalCategories=true

    this.resetRecomendCategory()
    
  }


  // getCategoryList(){



  //   if(this.allCategoryLoaded){
  //     console.log('all data category loaded');
  //     return
  //   }

  //   // this.dataCategoryList = null
  //   this.pageloading=true
  //   let first = this.categoryfirst
  //   let after = this.categoryendCursor
  //   console.log('prdlist, ',this.arrPrevCursor)
  //   // if(this.arrPrevCursor.lenght>1){
  //   //   after = this.arrPrevCursor[this.arrPrevCursor.lenght-1]
  //   // }

    
  //   // ReqType      : 'query' / 'mutation' 
  //   // ReqName      : ex :: rfqList / insertRfq / etc..
  //   // ArrParams    : ex :: { 'param':'companyLocationId', 'value':'01F84XE4F2MJY046GT19CBW15W', 'type':'ID!' }
  //   // Res          : ex :: '__typename,      ...on CompanyProduct {id          name          brand    description'   
  //   var ReqType = 'query'
  //   var ReqName = 'loadSystemIndustryList'
  //   var ArrParams = [
  //                     { 
  //                       'param':'first', 
  //                       'value': first, 
  //                       'type':'Int!' 
  //                     }, 
  //                     { 
  //                       'param':'after', 
  //                       'value':after, 
  //                       'type':'String!' 
  //                     }
  //                   ]
  //   var Res = 'pageInfo{ endCursor  hasNextPage } edges{  cursor  node{ id  industry  description } }'
  //   var setQueryGetCountry = Util.setQueryGQL(ReqType,ReqName,ArrParams,Res)
  //   console.log('setQueryGetCountry',setQueryGetCountry[0].gql);


  //   //var setVariableGQL= Util.setVariableGQL(ArrParams)

  //   // query loadSystemIndustryList ($first: Int!, $after: String!, ) {  loadSystemIndustryList(input: { first : $first after : $after  }) { pageInfo{ endCursor  hasNextPage } edges{  cursor  node{ id  industry  description } } } }

  //   this.apollo
  //   .mutate({
  //     // mutation: getCategory,
  //     mutation: gql`${setQueryGetCountry[0].gql}`,
  //     variables: {first: first, after: after}
  //     //variables: setVariableGQL
  //   })
  //   .subscribe(
  //     (res:any) => {
  //       console.log("succes, get data:", res);


  //       if(res.data){
  //         console.log("ada data");
  //         this.pageloading=false
  //         this.dataCategoryList = res.data.loadSystemIndustryList.edges
  //         console.log('dataCategoryList',this.dataCategoryList);

  //         var arrProd = res.data.loadSystemIndustryList.edges
  //         arrProd.forEach((value: any, key: any) => {
  //           this.AlldataCategoryList.push(value)
  //         })

  //         //add visible on search
  //         this.AlldataCategoryList.forEach((v:any,k:any) => {

  //           this.AlldataCategoryList[k]['display']=true
         
  //         });



  //         if(this.categoryendCursor!==''){
  //           this.categoryhasPrevPage = (this.categoryhasNextPage) ? true : false
  //         }
  //         console.log('categoryhasPrevPage',this.categoryhasPrevPage);

  //         this.categoryendCursor = res.data.loadSystemIndustryList.pageInfo.endCursor
  //         this.categoryhasNextPage = res.data.loadSystemIndustryList.pageInfo.hasNextPage
  //         console.log('categoryendCursor',this.categoryendCursor);
  //         console.log('categoryhasNextPage',this.categoryhasNextPage);


  //         this.allCategoryLoaded = !(this.categoryhasNextPage) ? true : false

  //         console.log('allCategoryLoaded',this.allCategoryLoaded);

  //         // localStorage.removeItem('PRODUCTLIST');
  //         // localStorage.setItem('PRODUCTLIST', JSON.stringify(this.AlldataRfq));

  //         // this.arrPrevCursor.push(after)
  //         // console.log('arrPrevCursor',this.arrPrevCursor);

  //         console.log('AlldataCategoryList',this.AlldataCategoryList);



  //         console.log('CategoryShown',this.CategoryShown);

  //         // if(this.categoryhasNextPage){
  //         //   this.CategoryPage++
  //         //   this.LastCategoryPage++
  //         // }
  //         this.CategoryPage++
  //         this.LastCategoryPage++

  //         console.log('CategoryPage',this.CategoryPage);
  //         console.log('CategoryPage',this.LastCategoryPage);


  //         var arrshownpage = this.CategoryPage * this.categoryfirst
  //         var start = arrshownpage - this.categoryfirst
  //         console.log('arrshownpage',arrshownpage);
  //         console.log('start',start);

  //         this.CategoryShown=[]
  //         for (let i = arrshownpage - this.categoryfirst; i < arrshownpage; i++) {
  //           this.CategoryShown.push(i)
  //         }


  //       }
  //     },
  //     error => {
  //       alert(error)
  //       console.log("there was an error sending the query", error);
  //       this.pageloading=false
  //     }
  //   );
  // }


  CategoryPrev(){
    this.ValSearchtext=''
    this.categoryhasNextPage =true
    this.CategoryPage--

    this.categoryhasPrevPage=(this.CategoryPage==1) ? false : true

    var arrshownpage = this.CategoryPage * this.categoryfirst

    this.CategoryShown=[]
    for (let i = arrshownpage - this.categoryfirst; i < arrshownpage; i++) {
      this.CategoryShown.push(i)
    }

    console.log('CategoryPage -> '+this.CategoryPage);
    console.log('LastCategoryPage -> '+this.LastCategoryPage);

  }
  CategoryNext(){
    this.ValSearchtext=''
    this.categoryhasPrevPage =true


    if(this.CategoryPage!==this.LastCategoryPage){
      this.CategoryPage++

      var arrshownpage = this.CategoryPage * this.categoryfirst

      this.CategoryShown=[]
      for (let i = arrshownpage - this.categoryfirst; i < arrshownpage; i++) {
        this.CategoryShown.push(i)
      }
      console.log('CategoryPage xx-> '+this.CategoryPage);
      console.log('LastCategoryPage xx-> '+this.LastCategoryPage);

      this.categoryhasNextPage = (this.CategoryPage==this.LastCategoryPage) ? false : true

      if(!this.allCategoryLoaded){
        this.categoryhasNextPage =true
      }

      return

    }

    console.log('CategoryPage -> '+this.CategoryPage);
    console.log('LastCategoryPage -> '+this.LastCategoryPage);

    //this.getCategoryList()
  }

  selectCategory(id:any){
    console.log('id',id);
    if(this.selectedCat.indexOf(id) !== -1){
      console.log('this '+ id +' exist in array bulk selectedCat');
      const index: number = this.selectedCat.indexOf(id);
      this.selectedCat.splice(index, 1);
    } else {
      this.selectedCat.push(id)
    }

    if(this.selectedCat.length>0){
      this.ValrfqVendorCategory = JSON.stringify(this.selectedCat)
    } else {
      this.ValrfqVendorCategory = ''
    }
    console.log('ValrfqVendorCategory', JSON.stringify(this.ValrfqVendorCategory));
    console.log('this.selectedCat',this.selectedCat);
  }

  getCategoryName(id:any){
      var name =''
      name = id

      this.AlldataCategoryList.forEach((v: any, k: any) => {
        if(id==v.node.industry){
          name = v.node.industry
        }
      });

      //if from edit data
      if(this.EditRfqId){
        this.arrCategoryfromEdit.forEach((v: any, k: any) => {
          if(id==v.category){
            name = v.category
          }
        });
      }

      return name
  }

  removeCat(id:any){
    this.selectedCat.forEach((v: any, k: any) => {
      if(v==id){
        this.selectedCat.splice(k, 1);
      }
    });

    if(this.selectedCat.length>0){
      this.ValrfqVendorCategory =  JSON.stringify(this.selectedCat)
    } else {
      this.ValrfqVendorCategory = ''
    }

    console.log('this.selectedCat',this.selectedCat);
  }


  openmodaldraft(){
    if(this.displaydraft=="none"){
      this.displaydraft = "block";
    } else {
      this.displaydraft = "none";
    }
  }

  openmodaldone(){
    if(this.displaydone=="none"){
      this.displaydone = "block";
    } else {
      this.displaydone = "none";
    }
  }

  resetData(){

  }

  CheckVal(val:any){
    if(val=='' || !val){
      return true
    } else {
      return false
    }
  }

  
  getDataEdit(RfqId: any){
    console.log('edit',RfqId);
    
    // var allprod = localStorage.getItem("MYRFQ")
    // var parse = allprod;

    // if(parse){
    //   var allprodArr = JSON.parse(parse);
    //   var x=0
    //   console.log('--->parse',allprodArr)
    //   allprodArr.forEach((obj: any) => {

    //     if(obj.node.id==RfqId){
    //       //set data
    //       console.log('--->',obj.node)




    //       this.ValcompanyLocationId=obj.node.companyLocation.id
    //       this.Valdescription=(obj.node.description!=='')?obj.node.description:"<fhspecdiv>[]</fhspecdiv>"
    //       //var dateValsubmitQuotationLastDate = new Date(obj.node.submitQuotationLastDate)
    //       // var ValidUntilmonth = dateValsubmitQuotationLastDate.getUTCMonth() + 1; //months from 1-12
    //       // var ValidUntilday = dateValsubmitQuotationLastDate.getUTCDate();
    //       // var ValidUntilyear = dateValsubmitQuotationLastDate.getUTCFullYear();

          
    //       var ValidUntilmonth = this.datepipe.transform(obj.node.submitQuotationLastDate, 'MM')
    //       var ValidUntilday = this.datepipe.transform(obj.node.submitQuotationLastDate, 'd')
    //       var ValidUntilyear = this.datepipe.transform(obj.node.submitQuotationLastDate, 'yyyy')


    //       console.log('ValidUntilmonth',ValidUntilmonth);
    //       console.log('ValidUntilday',ValidUntilday);
    //       console.log('ValidUntilyear',ValidUntilyear);


 

    //       var ValidUntildate = { "year": Number(ValidUntilyear), "month": Number(ValidUntilmonth), "day": Number(ValidUntilday) }
    //       console.log('ValidUntildate',ValidUntildate);
    //       this.ValsubmitQuotationLastDate= ValidUntildate 

    //       //var dateValetaRequested = new Date(obj.node.etaRequested)
    //       // var etaRequestedmonth = dateValetaRequested.getUTCMonth() + 1; //months from 1-12
    //       // var etaRequestedday = dateValetaRequested.getUTCDate();
    //       // var etaRequestedyear = dateValetaRequested.getUTCFullYear();


    //       var etaRequestedmonth = this.datepipe.transform(obj.node.etaRequested, 'MM')
    //       var etaRequestedday = this.datepipe.transform(obj.node.etaRequested, 'd')
    //       var etaRequestedyear = this.datepipe.transform(obj.node.etaRequested, 'yyyy')


    //       console.log('etaRequestedmonth',etaRequestedmonth);
    //       console.log('etaRequestedday',etaRequestedday);
    //       console.log('etaRequestedyear',etaRequestedyear);

    //       var etaRequesteddate = { "year": Number(etaRequestedyear), "month": Number(etaRequestedmonth), "day": Number(etaRequestedday) }  
    //       console.log('etaRequesteddate',etaRequesteddate);
    //       this.ValetaRequested=etaRequesteddate

    //       this.ValpaymentTermRequestedInDays=obj.node.paymentTermRequestedInDays
    //       this.Valcurrency=obj.node.currency
    //       this.ValprocurementRefNumber=obj.node.procurementRefNumber
    //       this.ValisForFullQuote=obj.node.isForFullQuote
    //       this.ValisIndentAccepted=obj.node.isIndentAccepted
    //       this.ValrfqItem=obj.node.rfqItem
    //       this.ValrfqVendorCategory='' // =obj.node.rfqVendorCategory

    //       this.arrCategoryfromEdit = obj.node.rfqVendorCategory
    //       if(obj.node.rfqVendorCategory instanceof Array){
    //         obj.node.rfqVendorCategory.forEach((e:any) => {
    //           this.selectedCat.push(e.category)
    //         });
    //         this.ValrfqVendorCategory=JSON.stringify(this.selectedCat)
    //       }
    //       console.log('selectedCat',this.selectedCat);

    //       this.ValCountry=obj.node.companyLocation.id
          
    //       this.ArrRfqItem=[]
          
    //       var TotalItem = obj.node.rfqItem.length
    //       for (let index = 0; index < obj.node.rfqItem.length; index++) {
    //         this.addProduct()

    //         // add fhspecdiv in specific item 

    //         // var descriptionWSpec = (!this.ValdescriptionProduct[key])?'':this.ValdescriptionProduct[key]
    //         // if(this.countarrFhSpec[key].length>0){
    //         //   descriptionWSpec = (!this.ValdescriptionProduct[key])?'':this.ValdescriptionProduct[key]+'<fhspecdiv>'+ JSON.stringify(this.countarrFhSpec[key]) +'</fhspecdiv>'
    //         // }
            
      


    //         this.Valname[index] = obj.node.rfqItem[index].name
    //         this.ValqtyNeeded[index] = obj.node.rfqItem[index].qtyNeeded
    //         this.ValmanufacturerSku[index] = obj.node.rfqItem[index].manufacturerSku
    //         this.Valbrand[index] = obj.node.rfqItem[index].brand
    //         this.ValdescriptionProduct[index] = obj.node.rfqItem[index].description
    //         this.ValqtyUnit[index] = obj.node.rfqItem[index].itemUnit

    //         console.log('this.ValdescriptionProduct',this.ValdescriptionProduct);
    //         // var arr = {
    //         //   name: this.Valname[index],
    //         //   brand: this.Valbrand[index],
    //         //   description: this.ValdescriptionProduct[index],
    //         //   qtyNeeded: this.ValqtyNeeded[index],
    //         //   manufacturerSku: this.ValmanufacturerSku[index],
    //         //   itemSequence: obj.node.rfqItem[index].itemSequence
    //         // }
    //         var arr:any = {}
    //         if(this.Valname[index]){ arr['name'] = this.Valname[index] }
    //         if(this.ValqtyNeeded[index]){ arr['qtyNeeded'] = this.ValqtyNeeded[index] }
    //         if(this.Valbrand[index]){ arr['brand'] = this.Valbrand[index] }
    //         if(this.ValdescriptionProduct[index]){ 
    //           arr['description'] = this.ValdescriptionProduct[index]; 
    //           var testz = Util.fhspectoarray(this.ValdescriptionProduct[index]); 
    //           console.log('testz',testz);  





    //          // this.countarrFhSpec[index].push(testz)
    //           if(testz){
    //             console.log('testz.length',testz.length);
    //             var idx = 0
    //             var arrays: any

    //             var CombineObj:any=[]
    //             testz.forEach((elm:any,idx:any) => {
    //               console.log('---------');
    //               // console.log('e',elm.label);
    //               // console.log('i:',idx);
    //               // console.log('---------');


    //               this.valspecValue[index]=''
    //               this.valspecLabel[index]=''
    //               this.valspecLabelErr[index] = false
    //               this.valspecValueErr[index] = false
            
    //               this.emptyLabelSpec[index].push({error:false})
    //               this.emptyValueSpec[index].push({error:false})
            
    //               this.ValSpecEmpty[index]=false
    //               //this..
    //               this.countarrFhSpec[index].push({label:elm.label,value:elm.value})

                  
    //               //CombineObj.push({label:elm.label,value:elm.value})


    //               console.log('---------');

    //               // this.countarrFhSpec.push(element)
     
    //               //this.countarrFhSpec[index]=elm
    //               //console.log('xx',this.countarrFhSpec)
    //               // this.countarrFhSpec[index].push({label:elm.label,value:elm.value})
    //               // this.valspecLabel.push(elm.label)
    //               // this.valspecValue.push(elm.value)
    //               idx++
    //               // console.log('arrays',arrays);
    //             });
    //             console.log('CombineObj::',CombineObj);
                
    //             //this.countarrFhSpec[index].push(CombineObj)
    //           }

    //           // this.countarrFhSpec[index].push(testz); 

    //           // this.countarrFhSpec[seq].push({label:this.valspecLabel[seq],value:this.valspecValue[seq]})

    //         }
    //         if(this.ValmanufacturerSku[index]){ arr['manufacturerSku'] = this.ValmanufacturerSku[index] }
    //         arr['itemSequence'] = obj.node.rfqItem[index].itemSequence

    //         console.log("arr['description']",arr['description']);
    //         this.ArrRfqItem.push(arr);

    //       }

    //       console.log('TotalItem',TotalItem);
    //       console.log("ArrRfqItem",this.ArrRfqItem);



    //     }
    //     x++
    //   });
    // }



    // // get by api
    // this.apollo
    // .mutate({
    //   mutation: getRrfqDetail,
    //   variables: {rfqId: RfqId}
    // })
    // .subscribe(
    //   (res:any) => {
    //     //console.log("succes, get data:", res);

        
    //     if(res.data){


    //       console.log('getEditFromAPI',res.data);
          
    //       this.ValcompanyLocationId=res.data.getRfqDetail.rfq.companyLocation.id
    //       console.log('ValcompanyLocationId>>>',this.ValcompanyLocationId);
    //       console.log('ValcompanyLocationId>>>',res.data.getRfqDetail.rfq.companyLocation);
    //       var loc = res.data.getRfqDetail.rfq.companyLocation
    //       this.ValCountry = loc.id
    //       this.ValCountryShow = loc.label+', '+loc.street+', '+loc.province+', '+loc.country
    //       this.ValCountryDetailarr = loc


    //       this.Valdescription=(res.data.getRfqDetail.rfq.description!=='')?res.data.getRfqDetail.rfq.description:"<fhspecdiv>[]</fhspecdiv>"
    //       //var dateValsubmitQuotationLastDate = new Date(res.data.getRfqDetail.rfq.submitQuotationLastDate)
    //       // var ValidUntilmonth = dateValsubmitQuotationLastDate.getUTCMonth() + 1; //months from 1-12
    //       // var ValidUntilday = dateValsubmitQuotationLastDate.getUTCDate();
    //       // var ValidUntilyear = dateValsubmitQuotationLastDate.getUTCFullYear();

          
    //       var ValidUntilmonth = this.datepipe.transform(res.data.getRfqDetail.rfq.submitQuotationLastDate, 'MM')
    //       var ValidUntilday = this.datepipe.transform(res.data.getRfqDetail.rfq.submitQuotationLastDate, 'd')
    //       var ValidUntilyear = this.datepipe.transform(res.data.getRfqDetail.rfq.submitQuotationLastDate, 'yyyy')


    //       console.log('ValidUntilmonth',ValidUntilmonth);
    //       console.log('ValidUntilday',ValidUntilday);
    //       console.log('ValidUntilyear',ValidUntilyear);


    // const date = moment(res.data.getRfqDetail.rfq.submitQuotationLastDate, moment.ISO_8601);
    // let todayDate = date.format('M/D/YYYY');
    // console.log('todayDate >> ',todayDate);
    // //alert(todayDate)

    //       var ValidUntildate = { "year": Number(ValidUntilyear), "month": Number(ValidUntilmonth), "day": Number(ValidUntilday) }
    //       console.log('ValidUntildate',ValidUntildate);

    //       this.ValsubmitQuotationLastDatePreview =this.datepipe.transform(res.data.getRfqDetail.rfq.submitQuotationLastDate, 'dd-MMM-yyyy');

    //       this.ValsubmitQuotationLastDate= ValidUntildate 

    //       //var dateValetaRequested = new Date(res.data.getRfqDetail.rfq.etaRequested)
    //       // var etaRequestedmonth = dateValetaRequested.getUTCMonth() + 1; //months from 1-12
    //       // var etaRequestedday = dateValetaRequested.getUTCDate();
    //       // var etaRequestedyear = dateValetaRequested.getUTCFullYear();


    //       var etaRequestedmonth = this.datepipe.transform(res.data.getRfqDetail.rfq.etaRequested, 'MM')
    //       var etaRequestedday = this.datepipe.transform(res.data.getRfqDetail.rfq.etaRequested, 'd')
    //       var etaRequestedyear = this.datepipe.transform(res.data.getRfqDetail.rfq.etaRequested, 'yyyy')


    //       console.log('etaRequestedmonth',etaRequestedmonth);
    //       console.log('etaRequestedday',etaRequestedday);
    //       console.log('etaRequestedyear',etaRequestedyear);

    //       var etaRequesteddate = { "year": Number(etaRequestedyear), "month": Number(etaRequestedmonth), "day": Number(etaRequestedday) }  
    //       console.log('etaRequesteddate',etaRequesteddate);
          
    //       if(etaRequestedday || etaRequestedmonth || etaRequestedyear){
    //         this.ValetaRequested=etaRequesteddate

    //         // var dateObj = moment(res.data.getRfqDetail.rfq.submitQuotationLastDate, moment.ISO_8601);
    //         // this.ValsubmitQuotationLastDatePreview = dateObj;


    //         this.ValetaRequestedPreview =this.datepipe.transform(res.data.getRfqDetail.rfq.etaRequested, 'dd-MMM-yyyy');
            

    //       } else {
    //         this.ValetaRequested=null

    //         this.ValetaRequestedPreview =null;
    //       }
    //       console.log('MMM ValetaRequested ',this.ValetaRequested);
          

    //       this.ValpaymentTermRequestedInDays=res.data.getRfqDetail.rfq.paymentTermRequestedInDays
    //       this.Valcurrency=res.data.getRfqDetail.rfq.currency
    //       this.ValprocurementRefNumber=res.data.getRfqDetail.rfq.procurementRefNumber
    //       this.ValisForFullQuote=res.data.getRfqDetail.rfq.isForFullQuote
    //       this.ValisIndentAccepted=res.data.getRfqDetail.rfq.isIndentAccepted
    //       this.ValrfqItem=res.data.getRfqDetail.rfq.rfqItem
    //       this.ValrfqVendorCategory='' // =res.data.getRfqDetail.rfq.rfqVendorCategory

    //       this.arrCategoryfromEdit = res.data.getRfqDetail.rfq.rfqVendorCategory
    //       if(res.data.getRfqDetail.rfq.rfqVendorCategory instanceof Array){
    //         res.data.getRfqDetail.rfq.rfqVendorCategory.forEach((e:any) => {
    //           this.selectedCat.push(e.category)
    //         });
    //         this.ValrfqVendorCategory=JSON.stringify(this.selectedCat)
    //       }
    //       console.log('selectedCat',this.selectedCat);

    //       this.ValCountry=res.data.getRfqDetail.rfq.companyLocation.id
          
    //       this.ArrRfqItem=[]
          
    //       var TotalItem = res.data.getRfqDetail.rfq.rfqItem.length
    //       for (let index = 0; index < res.data.getRfqDetail.rfq.rfqItem.length; index++) {
    //         this.addProduct()

    //         // add fhspecdiv in specific item 

    //         // var descriptionWSpec = (!this.ValdescriptionProduct[key])?'':this.ValdescriptionProduct[key]
    //         // if(this.countarrFhSpec[key].length>0){
    //         //   descriptionWSpec = (!this.ValdescriptionProduct[key])?'':this.ValdescriptionProduct[key]+'<fhspecdiv>'+ JSON.stringify(this.countarrFhSpec[key]) +'</fhspecdiv>'
    //         // }
            
      


    //         this.Valname[index] = res.data.getRfqDetail.rfq.rfqItem[index].name
    //         this.ValqtyNeeded[index] = res.data.getRfqDetail.rfq.rfqItem[index].qtyNeeded
    //         this.ValqtyNeededPrev[index] = res.data.getRfqDetail.rfq.rfqItem[index].qtyNeeded
            

    //         this.ValmanufacturerSku[index] = res.data.getRfqDetail.rfq.rfqItem[index].manufacturerSku
    //         this.Valbrand[index] = res.data.getRfqDetail.rfq.rfqItem[index].brand
    //         this.ValdescriptionProduct[index] = res.data.getRfqDetail.rfq.rfqItem[index].description
    //         this.ValqtyUnit[index] = res.data.getRfqDetail.rfq.rfqItem[index].itemUnit

    //         console.log('this.ValdescriptionProduct',this.ValdescriptionProduct);
    //         // var arr = {
    //         //   name: this.Valname[index],
    //         //   brand: this.Valbrand[index],
    //         //   description: this.ValdescriptionProduct[index],
    //         //   qtyNeeded: this.ValqtyNeeded[index],
    //         //   manufacturerSku: this.ValmanufacturerSku[index],
    //         //   itemSequence: res.data.getRfqDetail.rfq.rfqItem[index].itemSequence
    //         // }
    //         var arr:any = {}
    //         if(this.Valname[index]){ arr['name'] = this.Valname[index] }
    //         if(this.ValqtyNeeded[index]){ arr['qtyNeeded'] = this.ValqtyNeeded[index] }
    //         if(this.Valbrand[index]){ arr['brand'] = this.Valbrand[index] }
    //         if(this.ValdescriptionProduct[index]){ 
    //           arr['description'] = this.divDetailspec((this.ValdescriptionProduct[index])); 
    //           var testz = Util.fhspectoarray(this.ValdescriptionProduct[index]); 
    //           console.log('testz',testz);  

    //           //remap val desc
    //           this.ValdescriptionProduct[index]=this.divDetailspec((this.ValdescriptionProduct[index])); 



    //          // this.countarrFhSpec[index].push(testz)
    //           if(testz){
    //             console.log('testz.length',testz.length);
    //             var idx = 0
    //             var arrays: any

    //             var CombineObj:any=[]
    //             testz.forEach((elm:any,idx:any) => {
    //               console.log('---------');
    //               // console.log('e',elm.label);
    //               // console.log('i:',idx);
    //               // console.log('---------');


    //               this.valspecValue[index]=''
    //               this.valspecLabel[index]=''
    //               this.valspecLabelErr[index] = false
    //               this.valspecValueErr[index] = false
            
    //               this.emptyLabelSpec[index].push({error:false})
    //               this.emptyValueSpec[index].push({error:false})
            
    //               this.ValSpecEmpty[index]=false
    //               //this..
    //               this.countarrFhSpec[index].push({label:elm.label,value:elm.value})

                  
    //               //CombineObj.push({label:elm.label,value:elm.value})


    //               console.log('---------');

    //               // this.countarrFhSpec.push(element)
     
    //               //this.countarrFhSpec[index]=elm
    //               //console.log('xx',this.countarrFhSpec)
    //               // this.countarrFhSpec[index].push({label:elm.label,value:elm.value})
    //               // this.valspecLabel.push(elm.label)
    //               // this.valspecValue.push(elm.value)
    //               idx++
    //               // console.log('arrays',arrays);
    //             });
    //             console.log('CombineObj::',CombineObj);
                
    //             //this.countarrFhSpec[index].push(CombineObj)
    //           }

    //           // this.countarrFhSpec[index].push(testz); 

    //           // this.countarrFhSpec[seq].push({label:this.valspecLabel[seq],value:this.valspecValue[seq]})

    //         }
    //         if(this.ValmanufacturerSku[index]){ arr['manufacturerSku'] = this.ValmanufacturerSku[index] }
    //         arr['itemSequence'] = res.data.getRfqDetail.rfq.rfqItem[index].itemSequence

    //         console.log("arr['description']",arr['description']);
    //         this.ArrRfqItem.push(arr);

    //       }

    //       console.log('TotalItem',TotalItem);
    //       console.log("ArrRfqItem",this.ArrRfqItem);





    //     }
    //   },
    //   error => {
    //     alert(error)
    //     console.log("there was an error sending the query", error);     
    //     this.btnloading=false     
    //     this.pageloading = false  
    //   }
    // );



    this.rfqProcurementService
    .getRrfqDetail(RfqId)
    .subscribe((res:any) => {
      console.log('res : ',res)
      if(res.data.getRfqDetail){


        console.log('getEditFromAPI',res.data);
          
        this.ValcompanyLocationId=res.data.getRfqDetail.companyLocation.id
        console.log('ValcompanyLocationId>>>',this.ValcompanyLocationId);
        console.log('ValcompanyLocationId>>>',res.data.getRfqDetail.companyLocation);
        var loc = res.data.getRfqDetail.companyLocation
        this.ValCountry = loc.id
        this.ValCountryShow = (loc.label?loc.label+', ':'')+loc.street+', '+loc.province+', '+loc.country
        this.ValCountryDetailarr = loc


        this.Valdescription=(res.data.getRfqDetail.description!=='')?res.data.getRfqDetail.description:"<fhspecdiv>[]</fhspecdiv>"
        //var dateValsubmitQuotationLastDate = new Date(res.data.getRfqDetail.rfq.submitQuotationLastDate)
        // var ValidUntilmonth = dateValsubmitQuotationLastDate.getUTCMonth() + 1; //months from 1-12
        // var ValidUntilday = dateValsubmitQuotationLastDate.getUTCDate();
        // var ValidUntilyear = dateValsubmitQuotationLastDate.getUTCFullYear();

        
        var ValidUntilmonth = this.datepipe.transform(res.data.getRfqDetail.submitQuotationLastDate, 'MM')
        var ValidUntilday = this.datepipe.transform(res.data.getRfqDetail.submitQuotationLastDate, 'd')
        var ValidUntilyear = this.datepipe.transform(res.data.getRfqDetail.submitQuotationLastDate, 'yyyy')


        console.log('ValidUntilmonth',ValidUntilmonth);
        console.log('ValidUntilday',ValidUntilday);
        console.log('ValidUntilyear',ValidUntilyear);


  const date = moment(res.data.getRfqDetail.submitQuotationLastDate, moment.ISO_8601);
  let todayDate = date.format('M/D/YYYY');
  console.log('todayDate >> ',todayDate);
  //alert(todayDate)

        var ValidUntildate = { "year": Number(ValidUntilyear), "month": Number(ValidUntilmonth), "day": Number(ValidUntilday) }
        console.log('ValidUntildate',ValidUntildate);

        this.ValsubmitQuotationLastDatePreview =this.datepipe.transform(res.data.getRfqDetail.submitQuotationLastDate, 'dd-MMM-yyyy');

        this.ValsubmitQuotationLastDate= ValidUntildate 

        //var dateValetaRequested = new Date(res.data.getRfqDetail.rfq.etaRequested)
        // var etaRequestedmonth = dateValetaRequested.getUTCMonth() + 1; //months from 1-12
        // var etaRequestedday = dateValetaRequested.getUTCDate();
        // var etaRequestedyear = dateValetaRequested.getUTCFullYear();


        var etaRequestedmonth = this.datepipe.transform(res.data.getRfqDetail.etaRequested, 'MM')
        var etaRequestedday = this.datepipe.transform(res.data.getRfqDetail.etaRequested, 'd')
        var etaRequestedyear = this.datepipe.transform(res.data.getRfqDetail.etaRequested, 'yyyy')


        console.log('etaRequestedmonth',etaRequestedmonth);
        console.log('etaRequestedday',etaRequestedday);
        console.log('etaRequestedyear',etaRequestedyear);

        var etaRequesteddate = { "year": Number(etaRequestedyear), "month": Number(etaRequestedmonth), "day": Number(etaRequestedday) }  
        console.log('etaRequesteddate',etaRequesteddate);
        
        if(etaRequestedday || etaRequestedmonth || etaRequestedyear){
          this.ValetaRequested=etaRequesteddate

          // var dateObj = moment(res.data.getRfqDetail.rfq.submitQuotationLastDate, moment.ISO_8601);
          // this.ValsubmitQuotationLastDatePreview = dateObj;


          this.ValetaRequestedPreview =this.datepipe.transform(res.data.getRfqDetail.etaRequested, 'dd-MMM-yyyy');
          

        } else {
          this.ValetaRequested=null

          this.ValetaRequestedPreview =null;
        }
        console.log('MMM ValetaRequested ',this.ValetaRequested);
        
        console.log('res.data.getRfqDetail.paymentTermRequestedInDays : ',res.data.getRfqDetail.paymentTermRequestedInDays)
        this.ValpaymentTermRequestedInDaysPrev=res?.data?.getRfqDetail?.paymentTermRequestedInDays
        this.ValpaymentTermRequestedInDays=res?.data?.getRfqDetail?.paymentTermRequestedInDays

        console.log('xxxx  ValpaymentTermRequestedInDays : ',this.ValpaymentTermRequestedInDays)

        this.Valcurrency=res.data.getRfqDetail.currency
        this.ValprocurementRefNumber=res.data.getRfqDetail.procurementRefNumber
        this.ValisForFullQuote=res.data.getRfqDetail.isForFullQuote
        this.ValisIndentAccepted=res.data.getRfqDetail.isIndentAccepted
        this.ValrfqItem=res.data.getRfqDetail.rfqItem
        this.ValrfqVendorCategory='' // =res.data.getRfqDetail.rfq.rfqVendorCategory

        this.arrCategoryfromEdit = res.data.getRfqDetail.rfqVendorCategory
        if(res.data.getRfqDetail.rfqVendorCategory instanceof Array){
          res.data.getRfqDetail.rfqVendorCategory.forEach((e:any) => {
            this.selectedCat.push(e.category)
          });
          this.ValrfqVendorCategory=JSON.stringify(this.selectedCat)
        }
        console.log('selectedCat',this.selectedCat);

        this.ValCountry=res.data.getRfqDetail.companyLocation.id
        
        this.ArrRfqItem=[]
        
        var TotalItem = res.data.getRfqDetail.rfqItem.length
        for (let index = 0; index < res.data.getRfqDetail.rfqItem.length; index++) {
          this.addProduct()

          // add fhspecdiv in specific item 

          // var descriptionWSpec = (!this.ValdescriptionProduct[key])?'':this.ValdescriptionProduct[key]
          // if(this.countarrFhSpec[key].length>0){
          //   descriptionWSpec = (!this.ValdescriptionProduct[key])?'':this.ValdescriptionProduct[key]+'<fhspecdiv>'+ JSON.stringify(this.countarrFhSpec[key]) +'</fhspecdiv>'
          // }
          
    

          this.Valid[index] = res.data.getRfqDetail.rfqItem[index].id
          this.Valname[index] = res.data.getRfqDetail.rfqItem[index].name
          this.ValqtyNeeded[index] = res.data.getRfqDetail.rfqItem[index].qtyNeeded
          this.ValqtyNeededPrev[index] = res.data.getRfqDetail.rfqItem[index].qtyNeeded
          

          this.ValmanufacturerSku[index] = res.data.getRfqDetail.rfqItem[index].manufacturerSku
          this.Valbrand[index] = res.data.getRfqDetail.rfqItem[index].brand
          this.ValdescriptionProduct[index] = res.data.getRfqDetail.rfqItem[index].description
          this.ValqtyUnit[index] = res.data.getRfqDetail.rfqItem[index].itemUnit

          this.ValfileName[index] = res.data.getRfqDetail.rfqItem[index].fileName
          console.log('this.ValfileName[index] = ',this.ValfileName[index]);

          // set file first, then read base64 file as preview
          // crete object first then fill with function 'urltoFile'
          var setimg:any = []
          var imgName = 1
          for (let i=0; i<this.ValfileName[index].length ; i++){
            var ximgname = imgName+'.jpg'
            imgName++
            var arrobj = { 'val': this.ValfileName[index][i], 'name':ximgname, 'data': null, 'rfqItemId':res.data.getRfqDetail.rfqItem[index].id }
            setimg[i]=arrobj

            this.convertImage(this.ValfileName[index][i],index,ximgname)
          }
          this.imageSrcMore[index] = setimg
          console.log('this.imageSrcMore set form response = ',this.imageSrcMore);

          console.log('this.ValdescriptionProduct',this.ValdescriptionProduct);
          // var arr = {
          //   name: this.Valname[index],
          //   brand: this.Valbrand[index],
          //   description: this.ValdescriptionProduct[index],
          //   qtyNeeded: this.ValqtyNeeded[index],
          //   manufacturerSku: this.ValmanufacturerSku[index],
          //   itemSequence: res.data.getRfqDetail.rfq.rfqItem[index].itemSequence
          // }
          var arr:any = {}
          if(this.Valname[index]){ arr['name'] = this.Valname[index] }
          if(this.ValqtyNeeded[index]){ arr['qtyNeeded'] = this.ValqtyNeeded[index] }
          if(this.Valbrand[index]){ arr['brand'] = this.Valbrand[index] }
          if(this.ValdescriptionProduct[index]){ 
            arr['description'] = this.divDetailspec((this.ValdescriptionProduct[index])); 
            var testz = Util.fhspectoarray(this.ValdescriptionProduct[index]); 
            console.log('testz',testz);  

            //remap val desc
            this.ValdescriptionProduct[index]=this.divDetailspec((this.ValdescriptionProduct[index])); 



           // this.countarrFhSpec[index].push(testz)
            if(testz){
              console.log('testz.length',testz.length);
              var idx = 0
              var arrays: any

              var CombineObj:any=[]
              testz.forEach((elm:any,idx:any) => {
                console.log('---------');
                // console.log('e',elm.label);
                // console.log('i:',idx);
                // console.log('---------');


                this.valspecValue[index]=''
                this.valspecLabel[index]=''
                this.valspecLabelErr[index] = false
                this.valspecValueErr[index] = false
          
                this.emptyLabelSpec[index].push({error:false})
                this.emptyValueSpec[index].push({error:false})
          
                this.ValSpecEmpty[index]=false
                //this..
                this.countarrFhSpec[index].push({label:elm.label,value:elm.value})

                
                //CombineObj.push({label:elm.label,value:elm.value})


                console.log('---------');

                // this.countarrFhSpec.push(element)
   
                //this.countarrFhSpec[index]=elm
                //console.log('xx',this.countarrFhSpec)
                // this.countarrFhSpec[index].push({label:elm.label,value:elm.value})
                // this.valspecLabel.push(elm.label)
                // this.valspecValue.push(elm.value)
                idx++
                // console.log('arrays',arrays);
              });
              console.log('CombineObj::',CombineObj);
              
              //this.countarrFhSpec[index].push(CombineObj)
            }

            // this.countarrFhSpec[index].push(testz); 

            // this.countarrFhSpec[seq].push({label:this.valspecLabel[seq],value:this.valspecValue[seq]})

          }
          if(this.ValmanufacturerSku[index]){ arr['manufacturerSku'] = this.ValmanufacturerSku[index] }
          arr['itemSequence'] = res.data.getRfqDetail.rfqItem[index].itemSequence

          console.log("arr['description']",arr['description']);
          this.ArrRfqItem.push(arr);

        }

        console.log('TotalItem',TotalItem);
        console.log("ArrRfqItem",this.ArrRfqItem);



        console.log('this.imageSrcMore =>> ',this.imageSrcMore);
        this.generateFileFromAwsUrl()

      }
      else if(res.errors){
        var error = res.errors[0].message
        console.log('error',error);
        var errMsg = error + '';
        var result = errMsg.split(":");
        var resMsg = result[result.length - 1];
        var msg = (resMsg)? resMsg: errMsg
        console.log('msg',msg);

        var errortext = msg

        console.log('res',res.errors[0].extensions.type);
        if(res.errors[0].extensions.type){
          //get translate error, if exsit, replace errortext
          this.translate.get('error.'+res.errors[0].extensions.type).subscribe((data:any)=> {
            if (this.translate.instant('error.'+res.errors[0].extensions.type) !== 'error.'+res.errors[0].extensions.type){
              errortext = data
            }
          });
          //force redirect on specific errortype
          var forceRedirect = CheckErrortype.getResponse(res.errors[0].extensions.type)
          if(forceRedirect){
            window.location.href = forceRedirect
            return
          }
        }
        this.popupmodal.showError(errortext,null).subscribe((res:any) => {})
      }
      else {
        this.popupmodal.showFail().subscribe((res:any) => {})
      }
      
    });

  }

  
  generateFileFromAwsUrl(){
    for(let x=0; x < this.imageSrcMore.length;x++){
      this.imageSrcMore[x].forEach((element: string , key: number) => {
        if(this.imageSrcMore[x][key].val){
              this.toDataURL(this.imageSrcMore[x][key].val,  (dataUrl:any) => {
                if(dataUrl){
                  //base64 to image
                  var arr = dataUrl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                      bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
                  while(n--){
                      u8arr[n] = bstr.charCodeAt(n);
                  }
                  var ximgdata = new File([u8arr], this.imageSrcMore[x][key].name, {type:mime});
                  this.imageSrcMore[x][key].data = ximgdata
                }
              })
        }
      })
    }
    console.log('generateFileFromAwsUrl = this.imageSrcMore : ',this.imageSrcMore)
  }


  checkName(product:any,brand:any){
    if(product){
      if(brand){
        return '<b>'+brand+'</b> : '+ this.divDetailspecLess(product) 
      } else {
        return this.divDetailspecLess(product) 
      }
      
    } else {
      return this.translate.instant('rfq.tell_us_looking_for')
    }
  }
  divDetailspec(val:any){
    return Util.formatShortDesc(val)
  }
  divDetailspecLess(val:any){
    //return Util.formatShortDesc(val)
    var checkChar = Util.formatShortDesc(val)

    if(checkChar.length>50){
      checkChar = checkChar.substring(0,50) + '...'
    }
    return checkChar

  }

  getCurrency(newValue:any) {
    if(newValue){
      var getCur = newValue.match(/\(([^)]+)\)/)
      console.log('getCur',getCur);
      if(getCur){
        console.log('true',getCur[1]);
        this.Valcurrency= getCur[1]
      } else {
        console.log('false',newValue);
        this.Valcurrency = newValue
      }
    }
    console.log('getCurrency Valcurrency',this.Valcurrency);

  } 

  selectShipTo(loc:any){
    this.ValCountry = loc.id
    this.ValCountryShow = (loc.label?loc.label+', ':'')+loc.street+', '+loc.province+', '+loc.country
    this.ValCountryDetailarr = loc
  }

  loadingSearch(){
    this.iconloading=true
  }
  searchKeyword = new Subject<string>();
  callSearch(keyword:any){
    this.rfqProcurementService
    .getsearchCategory(keyword,10,'')
    .subscribe((res:any) => {
      this.iconloading=false

      if(res.data.loadSystemIndustryList){
        console.log("succes, get data:", res);
        this.resultKeyword = res.data.loadSystemIndustryList.edges
        if(this.resultKeyword.length==0){
          this.CategoryNotFound=true
        } else {
          this.CategoryNotFound=false
        }
      }
      else if(res.errors){

        var error = res.errors[0].message
        //this.loading=false
        console.log('error',error);
        var errMsg = error + '';
        var result = errMsg.split(":");
        var resMsg = result[result.length - 1];
        var msg = (resMsg)? resMsg: errMsg
        console.log('msg',msg);
        //alert(msg)

        var errortext = msg

        console.log('res',res.errors[0].extensions.type);
        if(res.errors[0].extensions.type){
          //get translate error, if exsit, replace errortext
          this.translate.get('error.'+res.errors[0].extensions.type).subscribe((data:any)=> {
            if (this.translate.instant('error.'+res.errors[0].extensions.type) !== 'error.'+res.errors[0].extensions.type){
              errortext = data
            }
          });
          //force redirect on specific errortype
          var forceRedirect = CheckErrortype.getResponse(res.errors[0].extensions.type)
          if(forceRedirect){
            window.location.href = forceRedirect
            return
          }
        }
        this.popupmodal.showError(errortext,null).subscribe((res:any) => {})
      }
      else {
        this.popupmodal.showFail().subscribe((res:any) => {})
      }
    });



  }
  
  typeSearchCategory(){
    console.log('>> ',this.ValSearchtext);
    this.CategoryNotFound=false

    if(this.ValSearchtext!==''){
      var totalfound=0
      var searchtolower = this.ValSearchtext.toUpperCase()
      this.AlldataCategoryList.forEach((v:any,k:any) => {
        var tolower = v.node.industry.toUpperCase()
        if (tolower.includes(searchtolower)) { 
          this.AlldataCategoryList[k].display=true
          totalfound++
        } else {
          this.AlldataCategoryList[k].display=false
        }
      });
      if(totalfound==0){
        this.CategoryNotFound=true
      }
    } else {
      this.AlldataCategoryList.forEach((v:any,k:any) => {
        this.AlldataCategoryList[k].display=true
      });
    }

  }

  // open(content:any) {
  //   this.modalCategory()
  //   this.modalReference = this.modalService.open(content,{centered: true});
  //   this.modalReference.result.then((result) => {
  //     this.closeResult = `Closed with: ${result}`;
  //   }, (reason) => {
  //     this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
  //   });
  // }
  open(content:any) {
    // this.modalCategory()
    this.modalReference = this.modalService.open(content,{centered: true});
    this.modalReference.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  private getDismissReason(reason: any): string {
    this.resetRecomendCategory()
    if (reason === ModalDismissReasons.ESC) {
      console.log('by pressing ESC');
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      console.log('by clicking on a backdrop');
      return 'by clicking on a backdrop';
    } else {
      console.log('with: ${reason}');
      return `with: ${reason}`;
    }
  }
  resetRecomendCategory(){
    this.valsuggestCategory=''
    this.suggestsubmitted = false

    this.iconloading=false
    this.CategoryNotFound=false
    this.onsearchKeyword = false
    this.valKeyword =''
  }

  get h() { return this.SuggestCategoryForm?.controls; }

  onSubmitSuggestion(){

    this.suggestsubmitted = true

    if (this.SuggestCategoryForm.invalid) {
      return
    }

    //alert('post api category suggestion')
    this.selectedCat.push(this.valsuggestCategory)


    // const modalRef = this.modalService.open(ModalComponent, {
    //   modalDialogClass: 'modal-dialog-centered',
    //   centered: true,
    //   backdrop : 'static',
    //   keyboard : false,
    //   size: 'sm'
    // })

    // modalRef.componentInstance.modalinfo = 'info'
    // modalRef.componentInstance.infoTitle = 'Success!' // 'Success!' 
    // modalRef.componentInstance.infoSuccess = 'Success submit category'
    // modalRef.componentInstance.infoFailed = null
    // modalRef.componentInstance.closeTxt = 'Close'

    this.resetRecomendCategory()

    console.log(this.modalReference);

    this.modalReference?.close();
    return;
    
  }

  onPaymentTermChange(val: any) {
    const parsed = parseFloat(val)
    if (parsed > 0) {
      this.ValpaymentTermRequestedInDaysPrev = parsed
    }
  }

  CheckValNumber(val: any) {
    if (val == '' || !val || !(parseFloat(val) > 0)) {
      return true
    } else {
      return false
    }
  }
  changeQtyPrev(val:any,key:any){
    this.ValqtyNeeded[key] = val.target.value.replaceAll(',', '');
  }


  changeDate(event: any) {
    console.log(event);

    var getYear = event?.year
    var getMonth = event?.month -1 
    var getDay = event?.day


    var changeDate = new Date(getYear, getMonth, getDay);
    var formatchangeDate =null
    if(getDay || getMonth || getYear){
      formatchangeDate =this.datepipe.transform(changeDate, 'dd-MMM-yyyy');
    }
    this.ValsubmitQuotationLastDatePreview = formatchangeDate
  }

  changeDateEta(event: any) {
    console.log(event);
    

    var getYear = event?.year
    var getMonth = event?.month -1 
    var getDay = event?.day


    var changeDate = new Date(getYear, getMonth, getDay);
    var formatchangeDate =null
    if(getDay || getMonth || getYear){
      formatchangeDate =this.datepipe.transform(changeDate, 'dd-MMM-yyyy');
    }
    this.ValetaRequestedPreview = formatchangeDate
  }
  

  checkDraftRfqForm(){
    const raw = localStorage.getItem('DRAFT_RFQ_FORM')
    if (!raw) { return false }

    const res = JSON.parse(raw)

    if (res.companyLocationId) {
      this.ValCountry = res.companyLocationId
      this.ValCountryShow = res.companyLocationLabel || res.companyLocationId
      this.ValCountryDetailarr = res.companyLocationDetail || []
    }

    this.Valdescription = res.description || '<fhspecdiv>[]</fhspecdiv>'
    this.ValpaymentTermRequestedInDays = res.paymentTermRequestedInDays
    this.ValpaymentTermRequestedInDaysPrev = res.paymentTermRequestedInDays
    this.Valcurrency = res.currency || ''
    this.ValprocurementRefNumber = res.procurementRefNumber || ''
    this.ValisForFullQuote = res.isForFullQuote || false
    this.ValisIndentAccepted = res.isIndentAccepted !== undefined ? res.isIndentAccepted : true

    if (res.submitQuotationLastDate) {
      this.ValsubmitQuotationLastDate = res.submitQuotationLastDate
    }

    if (res.etaRequested) {
      this.ValetaRequested = res.etaRequested
    }

    if (res.rfqVendorCategory instanceof Array) {
      res.rfqVendorCategory.forEach((e: any) => {
        this.selectedCat.push(typeof e === 'string' ? e : e.category)
      })
      this.ValrfqVendorCategory = JSON.stringify(this.selectedCat)
    }

    // rfqItem has the actual field data; productList only has collapse/product/required metadata
    const items = (res.rfqItem && res.rfqItem.length > 0) ? res.rfqItem : (res.productList || [])
    this.ArrRfqItem = []
    for (let index = 0; index < items.length; index++) {
      // push directly to avoid the 700ms setTimeout in addProduct()
      this.productList.push({ collapse: true, product: null, required: true })
      this.countarrFhSpec.push([])
      this.valspecLabel.push('')
      this.valspecValue.push('')
      this.ValSpecEmpty.push(false)
      this.valspecValueErr.push(false)
      this.valspecLabelErr.push(false)
      this.emptyLabelSpec.push([{ error: false }])
      this.emptyValueSpec.push([{ error: false }])
      this.ValqtyUnit.push('Pcs')

      this.Valname[index] = items[index].name
      this.ValqtyNeeded[index] = items[index].qtyNeeded
      this.ValmanufacturerSku[index] = items[index].manufacturerSku
      this.Valbrand[index] = items[index].brand
      this.ValqtyUnit[index] = items[index].itemUnit || 'Pcs'
      this.ValqtyNeededPrev[index] = items[index].qtyNeeded

      if (items[index].description) {
        const specs = Util.fhspectoarray(items[index].description)
        if (specs && specs.length > 0) {
          this.ValdescriptionProduct[index] = this.divDetailspec(items[index].description)
          specs.forEach((elm: any) => {
            this.emptyLabelSpec[index].push({ error: false })
            this.emptyValueSpec[index].push({ error: false })
            this.countarrFhSpec[index].push({ label: elm.label, value: elm.value })
          })
        } else {
          this.ValdescriptionProduct[index] = this.divDetailspec(items[index].description)
        }
      }

      const arr: any = {}
      if (this.Valname[index]) { arr['name'] = this.Valname[index] }
      if (this.ValqtyNeeded[index]) { arr['qtyNeeded'] = this.ValqtyNeeded[index] }
      if (this.Valbrand[index]) { arr['brand'] = this.Valbrand[index] }
      if (this.ValdescriptionProduct[index]) { arr['description'] = this.ValdescriptionProduct[index] }
      if (this.ValmanufacturerSku[index]) { arr['manufacturerSku'] = this.ValmanufacturerSku[index] }
      arr['itemSequence'] = items[index].itemSequence || (index + 1)
      this.ArrRfqItem.push(arr)
    }

    if (res.imageSrcMore instanceof Array) {
      this.imageSrcMore = res.imageSrcMore.map((arr: any[]) =>
        arr ? arr.map((img: any) => ({ val: img.val, name: img.name, data: null, rfqItemId: img.rfqItemId })) : []
      )
    }

    // localStorage.removeItem('DRAFT_RFQ_FORM')
    return true
  }

  checkRedirectReccurring(){
    var rfqreccurring = localStorage.getItem("RFQRECCURRING")
    console.log('rfqreccurring --- ',rfqreccurring);
    //check if owner, show approve or reject

    if(rfqreccurring){
      var arrrfqreccurring = JSON.parse(rfqreccurring)
      console.log(arrrfqreccurring)

      var res:any =null
      res = arrrfqreccurring


      console.log('getEditFromAPI',res.data);
          
      this.ValcompanyLocationId=res.companyLocation.id
      console.log('ValcompanyLocationId>>>',this.ValcompanyLocationId);
      console.log('ValcompanyLocationId>>>',res.companyLocation);
      var loc = res.companyLocation
      this.ValCountry = loc.id
      this.ValCountryShow = (loc.label?loc.label+', ':'')+loc.street+', '+loc.province+', '+loc.country
      this.ValCountryDetailarr = loc


      this.Valdescription=(res.description!=='')?res.description:"<fhspecdiv>[]</fhspecdiv>"
      //var dateValsubmitQuotationLastDate = new Date(res.data.getRfqDetail.rfq.submitQuotationLastDate)
      // var ValidUntilmonth = dateValsubmitQuotationLastDate.getUTCMonth() + 1; //months from 1-12
      // var ValidUntilday = dateValsubmitQuotationLastDate.getUTCDate();
      // var ValidUntilyear = dateValsubmitQuotationLastDate.getUTCFullYear();

      
    //   var ValidUntilmonth = this.datepipe.transform(res.submitQuotationLastDate, 'MM')
    //   var ValidUntilday = this.datepipe.transform(res.submitQuotationLastDate, 'd')
    //   var ValidUntilyear = this.datepipe.transform(res.submitQuotationLastDate, 'yyyy')


    //   console.log('ValidUntilmonth',ValidUntilmonth);
    //   console.log('ValidUntilday',ValidUnt xilday);
    //   console.log('ValidUntilyear',ValidUntilyear);


    // const date = moment(res.submitQuotationLastDate, moment.ISO_8601);
    // let todayDate = date.format('M/D/YYYY');
    // console.log('todayDate >> ',todayDate);
    // //alert(todayDate)




      // var ValidUntildate = { "year": Number(ValidUntilyear), "month": Number(ValidUntilmonth), "day": Number(ValidUntilday) }
      // console.log('ValidUntildate',ValidUntildate);
      // this.ValsubmitQuotationLastDate= ValidUntildate 


    //   var etaRequestedmonth = this.datepipe.transform(res.etaRequested, 'MM')
    //   var etaRequestedday = this.datepipe.transform(res.etaRequested, 'd')
    //   var etaRequestedyear = this.datepipe.transform(res.etaRequested, 'yyyy')


    //   console.log('etaRequestedmonth',etaRequestedmonth);
    //   console.log('etaRequestedday',etaRequestedday);
    //   console.log('etaRequestedyear',etaRequestedyear);

    //   var etaRequesteddate = { "year": Number(etaRequestedyear), "month": Number(etaRequestedmonth), "day": Number(etaRequestedday) }  
    //   console.log('etaRequesteddate',etaRequesteddate);
      
    //   if(etaRequestedday || etaRequestedmonth || etaRequestedyear){
    //     this.ValetaRequested=etaRequesteddate

    //     var dateObj = moment(res.submitQuotationLastDate, moment.ISO_8601);
    //     this.ValsubmitQuotationLastDatePreview = dateObj;


    //   } else {
    //     this.ValetaRequested=null
    //   }
    //   console.log('MMM ValetaRequested ',this.ValetaRequested);
      

      this.ValpaymentTermRequestedInDays=res.paymentTermRequestedInDays
      this.ValpaymentTermRequestedInDaysPrev=res.paymentTermRequestedInDays
      this.Valcurrency=res.currency
      this.ValprocurementRefNumber=res.procurementRefNumber
      this.ValisForFullQuote=res.isForFullQuote
      this.ValisIndentAccepted=res.isIndentAccepted
      this.ValrfqItem=res.rfqItem
      this.ValrfqVendorCategory='' // =res.data.getRfqDetail.rfq.rfqVendorCategory


            
      //submitQuotationLastDate

      this.arrCategoryfromEdit = res.rfqVendorCategory
      if(res.rfqVendorCategory instanceof Array){
        res.rfqVendorCategory.forEach((e:any) => {
          this.selectedCat.push(e.category)
        });
        this.ValrfqVendorCategory=JSON.stringify(this.selectedCat)
      }
      console.log('selectedCat',this.selectedCat);

      this.ValCountry=res.companyLocation.id
      
      this.ArrRfqItem=[]
      
      var TotalItem = res.rfqItem.length
      for (let index = 0; index < res.rfqItem.length; index++) {
        this.addProduct()

        // add fhspecdiv in specific item 

        // var descriptionWSpec = (!this.ValdescriptionProduct[key])?'':this.ValdescriptionProduct[key]
        // if(this.countarrFhSpec[key].length>0){
        //   descriptionWSpec = (!this.ValdescriptionProduct[key])?'':this.ValdescriptionProduct[key]+'<fhspecdiv>'+ JSON.stringify(this.countarrFhSpec[key]) +'</fhspecdiv>'
        // }
        
        

        this.Valname[index] = res.rfqItem[index].name
        this.ValqtyNeeded[index] = res.rfqItem[index].qtyNeeded
        this.ValmanufacturerSku[index] = res.rfqItem[index].manufacturerSku
        this.Valbrand[index] = res.rfqItem[index].brand
        this.ValdescriptionProduct[index] = res.rfqItem[index].description
        this.ValqtyUnit[index] = res.rfqItem[index].itemUnit

        this.ValqtyNeededPrev[index] = res.rfqItem[index].qtyNeeded
        

        console.log('this.ValdescriptionProduct',this.ValdescriptionProduct);

        var arr:any = {}
        if(this.Valname[index]){ arr['name'] = this.Valname[index] }
        if(this.ValqtyNeeded[index]){ arr['qtyNeeded'] = this.ValqtyNeeded[index] }
        if(this.Valbrand[index]){ arr['brand'] = this.Valbrand[index] }
        if(this.ValdescriptionProduct[index]){ 
          arr['description'] = this.divDetailspec((this.ValdescriptionProduct[index])); 
          var testz = Util.fhspectoarray(this.ValdescriptionProduct[index]); 
          console.log('testz',testz);  

          //remap val desc
          this.ValdescriptionProduct[index]=this.divDetailspec((this.ValdescriptionProduct[index])); 



         // this.countarrFhSpec[index].push(testz)
          if(testz){
            console.log('testz.length',testz.length);
            var idx = 0
            var arrays: any

            var CombineObj:any=[]
            testz.forEach((elm:any,idx:any) => {
              console.log('---------');
              // console.log('e',elm.label);
              // console.log('i:',idx);
              // console.log('---------');


              this.valspecValue[index]=''
              this.valspecLabel[index]=''
              this.valspecLabelErr[index] = false
              this.valspecValueErr[index] = false
        
              this.emptyLabelSpec[index].push({error:false})
              this.emptyValueSpec[index].push({error:false})
        
              this.ValSpecEmpty[index]=false
              //this..
              this.countarrFhSpec[index].push({label:elm.label,value:elm.value})

              
              //CombineObj.push({label:elm.label,value:elm.value})


              console.log('---------');

              // this.countarrFhSpec.push(element)
 
              //this.countarrFhSpec[index]=elm
              //console.log('xx',this.countarrFhSpec)
              // this.countarrFhSpec[index].push({label:elm.label,value:elm.value})
              // this.valspecLabel.push(elm.label)
              // this.valspecValue.push(elm.value)
              idx++
              // console.log('arrays',arrays);
            });
            console.log('CombineObj::',CombineObj);
            
            //this.countarrFhSpec[index].push(CombineObj)
          }

          // this.countarrFhSpec[index].push(testz); 

          // this.countarrFhSpec[seq].push({label:this.valspecLabel[seq],value:this.valspecValue[seq]})

        }
        if(this.ValmanufacturerSku[index]){ arr['manufacturerSku'] = this.ValmanufacturerSku[index] }
        arr['itemSequence'] = res.rfqItem[index].itemSequence


        

        console.log("arr['description']",arr['description']);
        this.ArrRfqItem.push(arr);

      }

      console.log('TotalItem',TotalItem);
      console.log("ArrRfqItem",this.ArrRfqItem);

      localStorage.removeItem('RFQRECCURRING');


      return true
    } else {
      console.log('rfqreccurring else.. ')
      return false
    }
    
  }

  checkRepeatRfq(){

    var RepeatRfq = localStorage.getItem("RepeatRfq")
    console.log('RepeatRfq --- ',RepeatRfq);
    //check if owner, show approve or reject

    if(RepeatRfq){
      var arrRepeatRfq = JSON.parse(RepeatRfq)
      console.log(arrRepeatRfq)

      var res:any =null
      res = arrRepeatRfq


      console.log('getEditFromAPI',res);

      this.ValcompanyLocationId=res?.companyLocation?.id

      if(this.ValcompanyLocationId){
        console.log('ValcompanyLocationId>>>',this.ValcompanyLocationId);
        console.log('ValcompanyLocationId>>>',res.companyLocation);
        var loc = res.companyLocation
        this.ValCountry = loc.id
        this.ValCountryShow = (loc.label?loc.label+', ':'')+loc.street+', '+loc.province+', '+loc.country
        this.ValCountryDetailarr = loc
      }    
      



      this.Valdescription=(res.description!=='')?res.description:"<fhspecdiv>[]</fhspecdiv>"


      this.ValpaymentTermRequestedInDays=res.paymentTermRequestedInDays
      this.ValpaymentTermRequestedInDaysPrev=res.paymentTermRequestedInDays
      this.Valcurrency=res.currency
      this.ValprocurementRefNumber=res.procurementRefNumber
      this.ValisForFullQuote=res.isForFullQuote
      this.ValisIndentAccepted=res.isIndentAccepted
      this.ValrfqItem=res.rfqItem
      this.ValrfqVendorCategory='' // =res.data.getRfqDetail.rfq.rfqVendorCategory


            
      //submitQuotationLastDate

      this.arrCategoryfromEdit = res.rfqVendorCategory
      if(res.rfqVendorCategory instanceof Array){
        res.rfqVendorCategory.forEach((e:any) => {
          this.selectedCat.push(e.category)
        });
        this.ValrfqVendorCategory=JSON.stringify(this.selectedCat)
      }
      console.log('selectedCat',this.selectedCat);

      this.ValCountry=res?.companyLocation?.id
      
      this.ArrRfqItem=[]
      
      var TotalItem = res.rfqItem.length
      for (let index = 0; index < res.rfqItem.length; index++) {
        this.addProduct()



        this.Valname[index] = res.rfqItem[index].name
        this.ValqtyNeeded[index] = res.rfqItem[index].qtyNeeded
        this.ValmanufacturerSku[index] = res.rfqItem[index].manufacturerSku
        this.Valbrand[index] = res.rfqItem[index].brand
        this.ValdescriptionProduct[index] = res.rfqItem[index].description
        this.ValqtyUnit[index] = res.rfqItem[index].itemUnit

        this.ValqtyNeededPrev[index] = res.rfqItem[index].qtyNeeded
        

        console.log('this.ValdescriptionProduct',this.ValdescriptionProduct);

        var arr:any = {}
        if(this.Valname[index]){ arr['name'] = this.Valname[index] }
        if(this.ValqtyNeeded[index]){ arr['qtyNeeded'] = this.ValqtyNeeded[index] }
        if(this.Valbrand[index]){ arr['brand'] = this.Valbrand[index] }
        if(this.ValdescriptionProduct[index]){ 
          arr['description'] = this.divDetailspec((this.ValdescriptionProduct[index])); 
          var testz = Util.fhspectoarray(this.ValdescriptionProduct[index]); 
          console.log('testz',testz);  

          //remap val desc
          this.ValdescriptionProduct[index]=this.divDetailspec((this.ValdescriptionProduct[index])); 



         // this.countarrFhSpec[index].push(testz)
          if(testz){
            console.log('testz.length',testz.length);
            var idx = 0
            var arrays: any

            var CombineObj:any=[]
            testz.forEach((elm:any,idx:any) => {
              console.log('---------');
              // console.log('e',elm.label);
              // console.log('i:',idx);
              // console.log('---------');


              this.valspecValue[index]=''
              this.valspecLabel[index]=''
              this.valspecLabelErr[index] = false
              this.valspecValueErr[index] = false
        
              this.emptyLabelSpec[index].push({error:false})
              this.emptyValueSpec[index].push({error:false})
        
              this.ValSpecEmpty[index]=false
              //this..
              this.countarrFhSpec[index].push({label:elm.label,value:elm.value})

              
              //CombineObj.push({label:elm.label,value:elm.value})


              console.log('---------');

              idx++
              // console.log('arrays',arrays);
            });
            console.log('CombineObj::',CombineObj);
            
          }


        }
        if(this.ValmanufacturerSku[index]){ arr['manufacturerSku'] = this.ValmanufacturerSku[index] }
        arr['itemSequence'] = res.rfqItem[index].itemSequence


        

        console.log("arr['description']",arr['description']);
        this.ArrRfqItem.push(arr);

      }
      //open all tab
      this.productList.forEach((value: any, key: any) => {
        this.productList[key]['collapse']=true
      })

      console.log('TotalItem',TotalItem);
      console.log("ArrRfqItem",this.ArrRfqItem);
      console.log('checkRepeatRfq remove localstorage.. ')
      localStorage.removeItem('RepeatRfq');


      this.generateFileFromAwsUrl()

      return true
    } else {
      console.log('checkRepeatRfq else.. ')
      return false
    }
    
  }

  // onTypepaymentTerm(e:any){
  //   var maxbid = parseInt(this.ValpaymentTermRequestedInDaysPrev)
  //   this.ValpaymentTermRequestedInDays = maxbid
  //   alert(maxbid)
  // }
  onFileChangeMultipleUpload(event: any,itemIndex:number) {
    if(!this.validateImg(event,itemIndex)){
      this.ValimageMoreText[itemIndex]=[]
      return
    }

    const files = event.target.files;
    if (!this.imageSrcMore[itemIndex]) { this.imageSrcMore[itemIndex] = [] }

    for (let i = 0; i < files.length; i++) {
      const file = files[i]
      const formData = new FormData()
      formData.append('image', file)

      const insertIndex = this.imageSrcMore[itemIndex].length
      this.imageSrcMore[itemIndex].push({ 'val': '', 'name': file.name, 'data': file, 'rfqItemId': this.Valid[itemIndex] })

      this.pageloading = true
      this.http.post<any>('/draftupload', formData).subscribe({
        next: (res: any) => {
          if (res && res.data) {
            this.imageSrcMore[itemIndex][insertIndex].val = 'http://localhost:4400' + res.data
            this.imageSrcMore[itemIndex][insertIndex].data = null
          }
          this.pageloading = false
          this.saveDraftImages()
        },
        error: (err: any) => {
          console.error('Upload image failed', err)
          this.imageSrcMore[itemIndex].splice(insertIndex, 1)
          const status = err?.status
          // prefer server JSON body message over Angular's generic HTTP error text
          const serverMsg = err?.error?.message
          const msg = serverMsg || err?.message || 'Unknown error'
          if (status === 504 || status === 502 || status === 503) {
            this.errorUploadImg[itemIndex] = `Upload gagal: image server tidak tersedia (${status}). Coba lagi nanti.`
          } else if (status === 0) {
            this.errorUploadImg[itemIndex] = 'Upload gagal: tidak ada koneksi ke server.'
          } else if (status) {
            this.errorUploadImg[itemIndex] = `Upload gagal: ${msg}`
          } else {
            this.errorUploadImg[itemIndex] = `Upload gagal: ${msg}`
          }
          this.pageloading = false
        }
      })
    }

    this.ValimageMoreText[itemIndex]=[]
  }


  validateImg(event:any,itemIndex:number){
    this.errorUploadImg[itemIndex]=false
   

    let allowedExtension = ['image/jpeg', 'image/jpg', 'image/png','image/gif']; //,'image/bmp'
    
    var errorimg = 0
    let files = event.target.files;

    for (let i = 0; i < files.length; i++) {
      var img = event.target.files[i]
      if(img){
        if(allowedExtension.indexOf(img.type)>-1){
          console.log('img ok')
          //alert(img.name+' ok')
        } else {
          console.log('img not ok')
          //alert(img.name+' not ok')
          errorimg++
        }
  
        const fsize = img.size;
        const file = Math.round((fsize / 1024));
        // The size of the file.
        if (file >= 8192) {
            //alert("File too Big, please select a file less than 8mb");
            console.log('img file over 8mb ')
            errorimg++
        } 
  
      }
    }


    if(errorimg>0){
      this.errorUploadImg[itemIndex]='Image must less than 8Mb and image format only (jpeg/jpg/png/gif)'
      this.popupmodal.showError("Image must less than 8Mb and image format only (jpeg/jpg/png/gif)",null).subscribe((res:any) => {})
      return false
    } else{
      return true
    }
  }

  onclickMoreImg(idx:number){
    console.log(idx); 
    let element:HTMLElement = document.getElementById('MoreImg'+idx) as HTMLElement;
    element.click();
  }

  postUpdateImage(action:string){
    

    // console.log('this.imageSrc : ', this.imageSrc);
    // console.log('this.ValimageFileName : ', this.ValimageFileName);


    // console.log('this.imageSrcData : ', this.imageSrcData);
    // console.log('this.imageSrcMore : ', this.imageSrcMore);

    

    // if(!this.imageSrc){
    //   return
    // }


    this.CombineImg = [];
    this.CombineImgData = [];

    // if(this.imageSrcData){
    //   this.CombineImg.push(this.FilenamePirmaryImg)
    //   this.CombineImgData.push(this.imageSrcData)
    // }

    

    console.log('---- postUpdateImage ----')
    console.log('CombineImg', this.CombineImg);
    console.log('CombineImgData', this.CombineImgData);
    console.log('imageSrcMore', this.imageSrcMore);



    var getLastIdImg =0;
    var getLAstIdForUpload = 0
    // this.getImgDetail.forEach((obj: any) => {

    //   var filename = Number(obj.substring(obj.lastIndexOf('/')+1).split('.')[0])
    //   if(!isNaN(filename)){
    //     console.log('filename => ',filename)
    //     if(getLastIdImg<filename){
    //       getLastIdImg = filename
    //     }
    //   }


    // })
    // getLAstIdForUpload = getLastIdImg
    // console.log('getLastIdImg => ',getLastIdImg)
    


    for(let x=0; x < this.imageSrcMore.length;x++){
      if(this.imageSrcMore[x]){
        var arrCmbImg:any = []
        var arrCmbImgData:any = []
        this.imageSrcMore[x].forEach((obj: any) => {
          if (obj.data) {
            arrCmbImg.push(obj.name)
            //arrCmbImgData.push(obj.data)
            arrCmbImgData.push(this.ArrResizeImage[x])
          }
        });
        if(arrCmbImg.length>0){
          this.CombineImg[x] = arrCmbImg
        }
        if(arrCmbImgData.length>0){
          this.CombineImgData[x] = arrCmbImgData
        }
        
        
      }

    }








    //UpdateimageData
    console.log('UpdateimageData : ',this.UpdateimageData)
    //check changes image
    console.log('imgAwsName : ',this.imgAwsName)
    
    this.UpdateimageData=[]
    // //set first img
    // if(this.imageSrcData){
    //   getLastIdImg++
    //   this.UpdateimageData.push(''+getLastIdImg+'.jpg')
    // } else{
    //   // use exist
    //   this.UpdateimageData.push(''+this.imgAwsName[0]+'.jpg')
      
    // }
    //set more img
    var exst=1


    for(let x=0; x < this.imageSrcMore.length;x++){
      
      if(this.imageSrcMore[x]){
        var arrUpdImg:any = []
        getLastIdImg = 0
        getLAstIdForUpload = 0
        this.imageSrcMore[x].forEach((element: string , key: number) => {
          console.log('imageSrcMore element >> ',element)
          console.log('imageSrcMore element val >> ',this.imageSrcMore[x][key].val)
          if(this.imageSrcMore[x][key].val){
            getLastIdImg++
            arrUpdImg.push(''+getLastIdImg+'.jpg')
          } else {
            arrUpdImg.push(''+this.imgAwsName[key+1]+'.jpg')
            exst++
          }
        })
        if(arrUpdImg.length>0){
          this.UpdateimageData[x] = arrUpdImg
        }
      }
    }


   
    //if no changes images.
    console.log(' exst ::',exst)
    console.log('getLastIdImg ::',getLastIdImg)
    if(exst>=getLastIdImg){
      // this.UpdateimageData=[]
      // this.CombineImg=[]
      // this.CombineImgData=[]
    } else {
      
      for(let x=0; x < this.imageSrcMore.length;x++){
        
        if(this.CombineImgData[x]){
          getLastIdImg = 0
          getLAstIdForUpload = 0
          // //---- replace img 1,2,3,4-----
          console.log('CombineImgData :: ',this.CombineImgData)
          this.CombineImgData[x].forEach((element: string | Blob, key: number) => {
            this.CombineImgData[x][key] = new File([element], (getLastIdImg+1)+".jpg");
            this.CombineImg[x][key] = (getLastIdImg+1)+".jpg"
            getLastIdImg++
          })

          console.log('CombineImg :: ',this.CombineImg)
          console.log('CombineImgData :: ',this.CombineImgData)


          // //----/replace img 1,2,3,4-----
        }

      }

    }

    console.log('post UpdateimageData ::',this.UpdateimageData)


    console.log('getLAstIdForUpload : ',getLAstIdForUpload)

    console.log('this.SuccessInsertorUpdate >> ',this.SuccessInsertorUpdate)
    for(let x=0; x < this.imageSrcMore.length;x++){
      
      if(this.CombineImgData[x]){
        getLastIdImg = 0 
        getLAstIdForUpload = 0
        // //---- replace img 1,2,3,4-----
        console.log('CombineImgData :: ',this.CombineImgData)
        this.CombineImgData[x].forEach((element: string | Blob, key: number) => {
          getLAstIdForUpload++
          this.CombineImgData[x][key] = new File([element], (getLAstIdForUpload)+".jpg");
          this.CombineImg[x][key] = (getLAstIdForUpload)+".jpg"
        })

        console.log('CombineImg :: ',this.CombineImg)
        console.log('CombineImgData :: ',this.CombineImgData)
        // //----/replace img 1,2,3,4-----
      }
    }




    var filename = this.Valname
    //var arrfile = this.arrImgName
    var arrfile = this.CombineImg
    var arrfileData = this.CombineImgData
    console.log('---- combine ----')
    console.log('productname', filename);
    console.log('arrfile', arrfile);
    console.log('arrfileData', arrfileData);

    // var filename = this.Valname
    // var arrfile = this.arrImgName

    this.totalUpload=arrfileData.length
    this.successUpload=0
    console.log('this.totalUpload : ',this.totalUpload)
    console.log('this.successUpload : ',this.successUpload)
    this.pageloading = false


    //prepare update img
    var rfqId = this.EditRfqId
    var dataArr = []
    var generatePreSignedUrlRfqItemInputData:any = []
    var setarrPostImgWithID:any = []
    for(let x=0; x < this.imageSrcMore.length;x++){
      if(this.imageSrcMore[x]){
        console.log('imageSrcMore == ',this.imageSrcMore[x])
        if(this.CombineImgData[x]){
          var flnm:any = []
          var fl:any=[]
          this.CombineImgData[x].forEach((e:any,idx:number) => {
            var filename = this.CombineImgData[x][idx]?.name
            var fileData = this.CombineImgData[x][idx]
            console.log('=== ',filename)
            flnm.push(filename)
            fl.push(fileData)
          });
          // dataArr.push({'rfqItemId':this.Valid[x],'fileName':flnm})
          // setarrPostImgWithID.push({'rfqItemId':this.Valid[x],'file':fl})

          if(action=='edit'){
            //is edit
            console.log('this.SuccessInsertorUpdate.rfqItem[x].id : ',this.SuccessInsertorUpdate.updateRfq.rfqItem[x].id)
            dataArr.push({'rfqItemId':this.SuccessInsertorUpdate.updateRfq.rfqItem[x].id,'fileName':flnm})
            setarrPostImgWithID.push({'rfqItemId':this.SuccessInsertorUpdate.updateRfq.rfqItem[x].id,'file':fl})
          } else {
            //is insert
            console.log('this.SuccessInsertorUpdate.rfqItem[x].id : ',this.SuccessInsertorUpdate.insertRfq.rfqItem[x].id)
            dataArr.push({'rfqItemId':this.SuccessInsertorUpdate.insertRfq.rfqItem[x].id,'fileName':flnm})
            setarrPostImgWithID.push({'rfqItemId':this.SuccessInsertorUpdate.insertRfq.rfqItem[x].id,'file':fl})
          }

        }
      }
    }

    

    if(dataArr.length>0){
      generatePreSignedUrlRfqItemInputData = dataArr

      this.arrPostImgWithID = setarrPostImgWithID
    }

    
    // rfqId: "01GTC5MWB51QW3BCKEBT4XEKY1"
    // generatePreSignedUrlRfqItemInputData: [
    //     {
    //         rfqItemId: "ABCDE"
    //         fileName: ["1.jpg","2.jpg"]
    //     },
    //     {
    //         rfqItemId: "FGHIJ"
    //         fileName: ["a.jpg","b.jpg", "c.jpg"]
    //     },
    //     {
    //         rfqItemId: "KLMNO"
    //         fileName: ["a1.jpg"]
    //     },
    // ]
    // Valid

    console.log('rfqId = ',rfqId)
    console.log('generatePreSignedUrlRfqItemInputData = ',generatePreSignedUrlRfqItemInputData)

    //if update image
    if(generatePreSignedUrlRfqItemInputData.length>0){
      console.log('generatePreSignedUrlRfqItemInputData > 0 ')

      //rfqId, generatePreSignedUrlRfqItemInputData

      this.uploadImagesService.getgeneratePreSignedUrlRfqItem(rfqId,generatePreSignedUrlRfqItemInputData).subscribe((res:any) => {

      
        console.log(res)
        var delaytime = 125



        if(res.data?.generatePreSignedUrlRfqItem){
  
  
          this.productImagePreSignedUrl = res.data?.generatePreSignedUrlRfqItem
          this.executeIndependentTasksInParallelUpdate(action)
    
  
        }
        else if(res.errors){
          var error = res.errors[0].message
          console.log('error',error);
          var errMsg = error + '';
          var result = errMsg.split(":");
          var resMsg = result[result.length - 1];
          var msg = (resMsg)? resMsg: errMsg
          console.log('msg',msg);
          var errortext = msg
  
          if(res.errors[0].extensions.type){
            //get translate error, if exsit, replace errortext
            this.translate.get('error.'+res.errors[0].extensions.type).subscribe((data:any)=> {
              if (this.translate.instant('error.'+res.errors[0].extensions.type) !== 'error.'+res.errors[0].extensions.type){
                errortext = data
              }
            });
            // //force redirect on specific errortype
            // var forceRedirect = CheckErrortype.getResponse(res.errors[0].extensions.type)
            // if(forceRedirect){
            //   window.location.href = forceRedirect
            //   return
            // }
          }
          this.popupmodal.showError(errortext,null).subscribe((res:any) => {})
        }
        else {
          this.popupmodal.showFail().subscribe((res:any) => {})
        }
        
  
      });
    }
    //else update image, go to update
    else {
      // alert('submit edit data else')
      // return
      //this.EditData()
      console.log('submit edit data else')
      //this.successModalUpdate()

      if(action=='edit'){
        //is edit
        this.successModalUpdate()
      } else {
        //is insert
        this.successModalInsert()
      }

    }

  }

  executeIndependentTasksInParallelUpdate(action:string) {

    var ArrFile: any[] = []
    var ArrUrl: any[]= []
    var timedelay = 500


        // "generatePreSignedUrlRfqItem": [
        //     {
        //         "rfqItemId": "01HE4SV66EHETGW5ES0SRX30PE",
        //         "url": [
        //             "https://rfqitem-cepetdapet-dev.s3.ap-southeast-1.amazonaws.com/01HE4SV64VBX9SNSPATHRZ7MAP/01HE4SV66EHETGW5ES0SRX30PE/1.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Date=20231103T022034Z&X-Amz-SignedHeaders=host&X-Amz-Expires=59&X-Amz-Credential=AKIA2LY4HGG47AK2IOKK%2F20231103%2Fap-southeast-1%2Fs3%2Faws4_request&X-Amz-Signature=d153d42b4f3ca581cff2d8a01b33ad287f980d49b13e22ab31c08ffdcba7586a"
        //         ],
        //         "__typename": "GeneratePreSignedUrlRfqItemOutput"
        //     },
        //     {
        //         "rfqItemId": "01HE4SV66ES3QP5HCKWBT7TV1Y",
        //         "url": [
        //             "https://rfqitem-cepetdapet-dev.s3.ap-southeast-1.amazonaws.com/01HE4SV64VBX9SNSPATHRZ7MAP/01HE4SV66ES3QP5HCKWBT7TV1Y/1.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Date=20231103T022034Z&X-Amz-SignedHeaders=host&X-Amz-Expires=59&X-Amz-Credential=AKIA2LY4HGG47AK2IOKK%2F20231103%2Fap-southeast-1%2Fs3%2Faws4_request&X-Amz-Signature=c263ced6186a6a1d5832b133649e3374ee8ff5f7636a3eaf1d78349d447517b3",
        //             "https://rfqitem-cepetdapet-dev.s3.ap-southeast-1.amazonaws.com/01HE4SV64VBX9SNSPATHRZ7MAP/01HE4SV66ES3QP5HCKWBT7TV1Y/2.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Date=20231103T022034Z&X-Amz-SignedHeaders=host&X-Amz-Expires=59&X-Amz-Credential=AKIA2LY4HGG47AK2IOKK%2F20231103%2Fap-southeast-1%2Fs3%2Faws4_request&X-Amz-Signature=d066c2f28371c252df99090a43982de8f1d7dca9a5a71e145c422fb8a1ae52a8"
        //         ],
        //         "__typename": "GeneratePreSignedUrlRfqItemOutput"
        //     }
        // ]

    this.CombineImgData.forEach((element: string | Blob, key: number) => {

      // for(let x=0; x < this.imageSrcMore.length;x++){
      //   if(this.imageSrcMore[x]){
      //     if(this.imageSrcMore[x][0]){ // if any arr
      //       if(this.imageSrcMore[x][0].rfqItemId ==)
      //     }
          
      //   }
      // }

      for(let x=0; x < this.arrPostImgWithID.length;x++){
        
          if(this.arrPostImgWithID[x].rfqItemId == this.productImagePreSignedUrl[x].rfqItemId){

            this.arrPostImgWithID[x].file.forEach((el:any,idx:number) => {
              timedelay = timedelay + (300*key)
              ArrFile.push({'file':el,'url':this.productImagePreSignedUrl[x]['url'][idx],'time':timedelay})
              ArrUrl.push(this.productImagePreSignedUrl[x]['url'][idx])  
            });
            

          }
        

      }      
      console.log('ArrUrl ::: ',ArrFile)
      console.log('ArrFile ::: ',ArrFile)
      

      // if(this.productImagePreSignedUrl[key]){
      //   timedelay = timedelay + (1+key)
      //   ArrFile.push({'file':element,'url':this.productImagePreSignedUrl[key],'time':timedelay})
      //   ArrUrl.push(this.productImagePreSignedUrl[key])
      // }
    })
    ArrUrl = [ArrUrl]

    //rename file to 1.2.3.4jpg

    this.pageloading = true
    from(ArrUrl)
      .pipe(
        concatMap((x:any,k:any) => {
          console.log('x :',x)
          console.log('k :',k)
          return forkJoin(
            x.map((t:any,key:any) => {
              console.log('t ::: ',t)
              console.log('key ::: ',key)
              console.log('ArrFile[k][file] ::: ',ArrFile[key]['file'])
              console.log('ArrFile[k][time] ::: ',ArrFile[key]['time'])
              return this.uploadImagesService.uploadAwsS3(t,ArrFile[key]['file'],ArrFile[key]['time']).pipe(catchError(value => of({type: k, failed: true})));
            })
          );
        })
      )
      .subscribe((data:any) => {
        console.log('executeIndependentTasksInParallel done: ',data);

          var fail = 0
          if(data?.length>0){
            for(let result of data){
              if(result?.failed){
                fail++
              }
            }
          }

          this.pageloading = false

          console.log('executeIndependentTasksInParallel fail: ',fail);
          if(fail>0){
            //alert('ada gagal upload')
            console.log('Images failed to upload, please reupload again')
            //leave it broken img if any
            if(action=='edit'){
              this.successModalUpdate()
            } else {
              this.successModalInsert()
            }
            
            //this.popupmodal.showError('Images failed to upload, please reupload again',null).subscribe((res:any) => {})
          } else {
            // alert('submit edit data, done upload img')
            // return
            //this.EditData()
            if(action=='edit'){
              this.successModalUpdate()
            } else {
              this.successModalInsert()
            }
          }
      });

  }

  checkCartListStorage(){
    var checkCartListStorage = localStorage.getItem("CARTSTORAGE")
    if(checkCartListStorage){

      var arrRepeatRfq:any
      
      arrRepeatRfq= JSON.parse(checkCartListStorage)
      console.log('arrRepeatRfq >> ',arrRepeatRfq)

      var res:any =null
      res = arrRepeatRfq


      this.ValrfqItem=res.rfqItem
      this.ValrfqVendorCategory='' // =res.data.getRfqDetail.rfq.rfqVendorCategory


      
      this.ArrRfqItem=[]
      
      var TotalItem = res.rfqItem.length
      for (let index = 0; index < res.rfqItem.length; index++) {
        this.addProduct()

        // add fhspecdiv in specific item 

        // var descriptionWSpec = (!this.ValdescriptionProduct[key])?'':this.ValdescriptionProduct[key]
        // if(this.countarrFhSpec[key].length>0){
        //   descriptionWSpec = (!this.ValdescriptionProduct[key])?'':this.ValdescriptionProduct[key]+'<fhspecdiv>'+ JSON.stringify(this.countarrFhSpec[key]) +'</fhspecdiv>'
        // }
        
  

        this.Valid[index] = res.rfqItem[index].id
        this.Valname[index] = res.rfqItem[index].name
        this.ValqtyNeeded[index] = res.rfqItem[index].qtyNeeded
        this.ValqtyNeededPrev[index] = res.rfqItem[index].qtyNeeded
        

        this.ValmanufacturerSku[index] = res.rfqItem[index].manufacturerSku
        this.Valbrand[index] = res.rfqItem[index].brand
        this.ValdescriptionProduct[index] = res.rfqItem[index].description
        this.ValqtyUnit[index] = res.rfqItem[index].itemUnit?res.rfqItem[index].itemUnit:'Pcs'


        

        this.ValfileName[index] = res.rfqItem[index].fileName
        console.log('this.ValfileName[index] = ',this.ValfileName[index]);

        // set file first, then read base64 file as preview
        // crete object first then fill with function 'urltoFile'
        var setimg:any = []
        var imgName = 1
        for (let i=0; i<this.ValfileName[index].length ; i++){
          var ximgname = imgName+'.jpg'
          imgName++
          var arrobj = { 'val': this.ValfileName[index][i], 'name':ximgname, 'data': null, 'rfqItemId':null }
          setimg[i]=arrobj
        }
        this.imageSrcMore[index] = setimg
        console.log('this.imageSrcMore set form response = ',this.imageSrcMore);

        console.log('this.ValdescriptionProduct',this.ValdescriptionProduct);
        // var arr = {
        //   name: this.Valname[index],
        //   brand: this.Valbrand[index],
        //   description: this.ValdescriptionProduct[index],
        //   qtyNeeded: this.ValqtyNeeded[index],
        //   manufacturerSku: this.ValmanufacturerSku[index],
        //   itemSequence: res.data.getRfqDetail.rfq.rfqItem[index].itemSequence
        // }
        var arr:any = {}
        if(this.Valname[index]){ arr['name'] = this.Valname[index] }
        if(this.ValqtyNeeded[index]){ arr['qtyNeeded'] = this.ValqtyNeeded[index] }
        if(this.Valbrand[index]){ arr['brand'] = this.Valbrand[index] }
        if(this.ValdescriptionProduct[index]){ 
          arr['description'] = this.divDetailspec((this.ValdescriptionProduct[index])); 
          var testz = Util.fhspectoarray(this.ValdescriptionProduct[index]); 
          console.log('testz',testz);  

          //remap val desc
          this.ValdescriptionProduct[index]=this.divDetailspec((this.ValdescriptionProduct[index])); 



         // this.countarrFhSpec[index].push(testz)
          if(testz){
            console.log('testz.length',testz.length);
            var idx = 0
            var arrays: any

            var CombineObj:any=[]
            testz.forEach((elm:any,idx:any) => {
              console.log('---------');
              // console.log('e',elm.label);
              // console.log('i:',idx);
              // console.log('---------');


              this.valspecValue[index]=''
              this.valspecLabel[index]=''
              this.valspecLabelErr[index] = false
              this.valspecValueErr[index] = false
        
              this.emptyLabelSpec[index].push({error:false})
              this.emptyValueSpec[index].push({error:false})
        
              this.ValSpecEmpty[index]=false
              //this..
              this.countarrFhSpec[index].push({label:elm.label,value:elm.value})

              
              //CombineObj.push({label:elm.label,value:elm.value})


              console.log('---------');

              // this.countarrFhSpec.push(element)
 
              //this.countarrFhSpec[index]=elm
              //console.log('xx',this.countarrFhSpec)
              // this.countarrFhSpec[index].push({label:elm.label,value:elm.value})
              // this.valspecLabel.push(elm.label)
              // this.valspecValue.push(elm.value)
              idx++
              // console.log('arrays',arrays);
            });
            console.log('CombineObj::',CombineObj);
            
            //this.countarrFhSpec[index].push(CombineObj)
          }

          // this.countarrFhSpec[index].push(testz); 

          // this.countarrFhSpec[seq].push({label:this.valspecLabel[seq],value:this.valspecValue[seq]})

        }
        if(this.ValmanufacturerSku[index]){ arr['manufacturerSku'] = this.ValmanufacturerSku[index] }
        arr['itemSequence'] = res.rfqItem[index].itemSequence

        console.log("arr['description']",arr['description']);
        this.ArrRfqItem.push(arr);

      }

      console.log('TotalItem',TotalItem);
      console.log("ArrRfqItem",this.ArrRfqItem);

      //localStorage.removeItem('CARTSTORAGE');

      console.log('this.imageSrcMore =>> ',this.imageSrcMore);
      this.generateFileFromAwsUrl()

      return true
    } else {
      console.log('rfqreccurring else.. ')
      return false
    }



  }

  resizeImage(index:number,image:any,name:string, type:string) {
    console.log("resizeImage index : ", index)
    console.log("resizeImage name : ", name)
    console.log("resizeImage type : ", type)

    this.postResizeImage(image,name,type,index)
  }

  postResizeImage(image: File,fileName:string,typeValue:string,index:number){
    const formData = new FormData();
    formData.append('image', image);
    // this.http.post('imgs/upload/resize',formData, { responseType: 'blob' })
    // .subscribe(blob => {
    //   const file = new File([blob], fileName, { type: typeValue });

    //   this.ArrResizeImage[index]=file
    // }, error => {
    //   console.error('Error capturing image', error);
    // })
    this.pageloading=true
    this.http.post('imgs/upload/resize', formData, { responseType: 'blob' }).subscribe({
      next: (blob: Blob) => {
        const file = new File([blob], fileName, { type: typeValue });
        this.ArrResizeImage[index] = file;
        this.pageloading=false
      },
      error: (err: any) => {
        alert('Resize image failed, please re-upload image again')
        this.pageloading=false
      }
    });
  }
  

  convertImage(imageUrl: string, index:number, imageName:string): void {
    this.imgHandler.getFileFromUrl(imageUrl).subscribe({
      next: (file: File) => {
        console.log('File:', file);
        console.log('Type:', this.imgHandler.getFileType(file));
        console.log('Name:', this.imgHandler.getFileName(file));
        console.log('imageName:', imageName);
        var getType = this.imgHandler.getFileType(file)
        var getName = this.imgHandler.getFileName(file)
        if(file && getType!=="unknown" && getName!=="unknown-file"){
          console.log('Image, go resize image..');
          this.resizeImage(index,file,imageName,getType)
        }
      },
      error: (error: Error) => {
        console.error('Error:', error.message);
      }
    });
  }

  triggerFileInput(i:number){
    document.querySelector<HTMLInputElement>("#formFile_"+i)?.click();
  }
}
